/**
 * 
 */
function createURLfileLayer(urlFile, tipusFile, epsgIN, dinamic, nomCapa, colX, colY, tipusAcc, tipusFont, tipusCodi, nomCampCodi, colXY, separador,colWKT,
	campUnic,camps,separadorCamps,codiMsg){
	PopupManager();
	//Estil defecte
	var estil_do = InstamapsUtils.Styles.retornaEstilaDO(defaultPunt);
	var estil_lin_pol = estil_do;

	//Recuperem estils de la barra d'eines
	var lineStyle = getLineRangFromStyle(InstamapsUtils.Styles.getLineStyleFromToolbar("cv_linia", InstamapsConstants));
	lineStyle.weight = lineStyle.lineWidth;

	var polygonStyle = getPolygonRangFromStyle(InstamapsUtils.Styles.getPolygonStyleFromToolbar("cv_pol", InstamapsConstants));
	polygonStyle.weight = polygonStyle.borderWidth;//lineWidth;
	polygonStyle.fillColor = polygonStyle.color;
	polygonStyle.color = polygonStyle.borderColor;
	polygonStyle.fillOpacity = polygonStyle.opacity/100; 
	polygonStyle.opacity = 1;

	var markerStyle = getMarkerRangFromStyle(defaultPunt);

	if (colWKT!=undefined && colWKT!=null && colWKT!='' && tipusAcc!=='adreca'){
		tipusAcc = "gdal";
		ttipusCSV = "wkt";
	}


	if(markerStyle.isCanvas){
		estil_do.color = markerStyle.borderColor;
		estil_do.fillColor = markerStyle.color;
		estil_do.fillOpacity = 1;
		estil_do.opacity = 1;
		estil_do.radius = markerStyle.simbolSize;
		estil_do.weight = markerStyle.borderWidth;
	}else{
		estil_do.fillColor =  InstamapsUtils.Styles.getColorAwesomeMarker(markerStyle.marker, markerStyle.color);
	}

	//afegim codi unic als estils per poder contrar la llegenda dinàmica
	estil_do.codiUnic = InstamapsUtils.Getters.getCodiUnic();

	/***Parseig url en cas google drive****/
	//https://drive.google.com/file/d/FILE_ID/edit?usp=sharing
	//https://drive.google.com/uc?export=download&id=FILE_ID
	//https://drive.google.com/open?id=FILE_ID                                                                             

	if(urlFile.indexOf("https://drive.google.com/file/d/")!=-1){
		urlFile = urlFile.replace("https://drive.google.com/file/d/", "");
		var res = urlFile.split("/");
		var fileId = res[0];
		urlFile = "https://drive.google.com/uc?export=download&id="+fileId;
	}
	else if(urlFile.indexOf("https://drive.google.com/open?id")!=-1){
		urlFile=urlFile.replace("https://drive.google.com/open?id=","");
		var fileId = urlFile;
		urlFile=  "https://drive.google.com/uc?export=download&id="+fileId;
	}
	else if(urlFile.indexOf("https://www.dropbox.com")!=-1){
		urlFile = urlFile.replace("https://www.dropbox.com", "https://dl.dropboxusercontent.com");		
	}

	//Per fitxers excel (XLS,XLSX) el separador ha de ser ";"
	if (tipusFile.indexOf("xls")!==-1){
		separadorCamps = ";";
	}

	/*** DINAMIC ***/
	if(dinamic){
		busy = false;
		var propName = "";
		var urlFileHttps=urlFile;

		var isHttps=false;
		if (urlFile.indexOf("https")>-1 && urlFile.indexOf("csv")>-1 && urlFile.indexOf("spreadsheet")==-1 && tipusFile!=".json" && urlFile.indexOf("dropbox")==-1){//} || (urlFile.indexOf("spreadsheets")>-1)) {
			isHttps=true;
			if (urlFile.indexOf("https")>-1) {
				var HOST_APP4 = "http://www.instamaps.cat/";
				if (urlApp.indexOf("geocat1")>-1 || urlApp.indexOf("localhost")>-1)  HOST_APP4=HOST_APP3;				
				urlFile = HOST_APP4+paramUrl.proxy_betterWMS + "?url="+urlFile;

			}
			else {
				//if (urlFile.indexOf("instamaps.cat")==-1 && urlFile.indexOf("https")>-1 && urlFile.indexOf("dropbox")==-1 && urlFile.indexOf("sharepoint")==-1) urlFile = urlFile.replace("https","http");
			}    
		}

		//if (urlFile.indexOf("spreadsheet")==-1 && urlFile.indexOf("instamaps.cat")==-1 && urlFile.indexOf("https")>-1 && urlFile.indexOf("dropbox")==-1 && urlFile.indexOf("sharepoint")==-1 && urlFile.indexOf("analisi.transparenciacatalunya.cat/")==-1) urlFile = urlFile.replace("https","http");
		if (urlFile.indexOf("sharepoint")>-1){
			urlFile = urlFile+"&download=1";
		}
		if (urlApp.indexOf("geocat1")>-1)  urlFile = urlFile.replace("https","http");

		var param_url = paramUrl.urlFileDin	+"tipusFile=" + tipusFile+
		"&tipusAcc="+tipusAcc+
		"&tipusCodi="+tipusCodi+ 
		"&tipusFont="+tipusFont+
		"&nomCampCodi="+nomCampCodi+		
		"&epsgIN="+epsgIN+
		"&dinamic="+dinamic+
		"&uploadFile="+paramUrl.uploadFile+
		"&colX="+colX+
		"&colY="+colY+
		"&colWKT="+colWKT+
		"&uid="+Cookies.get('uid')+
		"&campUnic="+campUnic+
		"&camps="+camps+
		"&urlFile="+encodeURIComponent(urlFile)+
		"&separador="+separadorCamps;
		
		if ((urlFile.indexOf("socrata")>-1 || urlFile.indexOf("https")>-1) && (urlFile.indexOf("drive")==-1) && (urlFile.indexOf("spreadsheet")==-1)
				&& (urlFile.indexOf("dropbox")==-1) && (urlFile.indexOf("csv")==-1) && urlFile.indexOf("sharepoint")==-1) 	{
			param_url = urlFile;
		}

		
		
		if (tipusFile==".json"){
			 L.toGeoJSON.empty();
			 L.toGeoJSON.convert(urlFile,"Point",colX,colY, colXY, separador).then(function(){
				 
				  
				  var dataSocrata={
							serverName: nomCapa,
							jsonSocrata: JSON.stringify(L.toGeoJSON.geoJsonData)
					};
					
				//console.debug(dataSocrata);
				crearFitxerSocrata(dataSocrata).then(function(results){
					if (results.status="OK"){
						param_url =results.filePath;
						$('#dialog_dades_ex').modal('hide');
						$('#dialog_carrega_dades').modal('hide');
						jQuery("#div_uploading_txt").html("");
						jQuery("#div_uploading_txt").html('<div id="div_upload_step1" class="status_current" lang="ca"> '+
								window.lang.translate('Carregant dades')+
						'<span class="one">.</span><span class="two">.</span><span class="three">.</span></div>');		
						jQuery('#info_uploadFile').show();


					   if (param_url.indexOf("/opt/")>-1 || param_url.indexOf("\\temp\\")>-1 ){
						    if (param_url.indexOf("\\temp\\")>-1)  urlFile=HOST_HTTP+"/jsonfiles/"+param_url.substring(param_url.lastIndexOf("\\")+1,param_url.length);
						    else  urlFile=HOST_HTTP+"/jsonfiles/"+param_url.substring(param_url.lastIndexOf("/")+1,param_url.length);
							param_url = paramUrl.urlFileDin	+"tipusFile=" + ".geojson"+
							"&tipusAcc="+tipusAcc+
							"&tipusCodi="+tipusCodi+
							"&tipusFont="+tipusFont+
							"&nomCampCodi="+nomCampCodi+
							"&urlFile="+encodeURIComponent(urlFile)+
							"&epsgIN="+epsgIN+
							"&dinamic="+dinamic+
							"&uploadFile="+paramUrl.uploadFile+
							"&colX="+colX+
							"&colY="+colY+
							"&colWKT="+colWKT+
							"&campUnic="+campUnic+
							"&camps="+camps+
							//"&colXY="+colXY+
							"&uid="+Cookies.get('uid')+
							"&separador="+separadorCamps;		
						}
						
						var capaURLfile = new L.GeoJSON.AJAX(param_url, {
							nom : nomCapa,
							tipus : t_url_file,
							estil_do: estil_do,
							style: estil_lin_pol,//Estil de poligons i linies
							pointToLayer : function(feature, latlng) {
								var geom = L.circleMarker(latlng, estil_do);
								var pp = feature.properties;
								var html ='<div class="div_popup_visor"><div class="popup_pres">';
								propName = "";
								$.each( pp, function( key, value ) {
									propName = propName+key+",";
									if(InstamapsUtils.Validator.isValidValueNotWKT(value)){
										if ( key != 'businessId' && key != 'slotd50'  && key.toLowerCase()!="nomcapa" && key.toLowerCase()!="popupdata" &&
												key.toLowerCase()!="capanom" && key.toLowerCase()!="propname"){
													html += InstamapsUtils.Dom.getHtmlFromTxt(value,key);											
										}
									}
								});	
								propName = propName.substr(0, propName.length-1);
								html+='</div></div>'; 
								feature.properties.capaNom=nomCapa;
								feature.properties.popupData=html;
								geom.on('click', function(e) {
									createPopupMapaUrlFile(feature, e);
								});
								

								return geom;
							},
							onEachFeature : function(feature, latlng) {
								var pp = feature.properties;
								var html ='<div class="div_popup_visor"><div class="popup_pres">';
								propName = "";
								$.each( pp, function( key, value ) {
									propName = propName+key+",";
									if(InstamapsUtils.Validator.isValidValueNotWKT(value)){
										if ( key != 'businessId' && key != 'slotd50'  && key.toLowerCase()!="nomcapa" && key.toLowerCase()!="popupdata" &&
												key.toLowerCase()!="capanom" && key.toLowerCase()!="propname"){
													html += InstamapsUtils.Dom.getHtmlFromTxt(value,key);														
										}
									}
								});	
								propName = propName.substr(0, propName.length-1);
								html+='</div></div>'; 
								//latlng.feature.properties.capaNom = nomCapa;
								//latlng.feature.properties.popupData=html;
								latlng.properties={
									capaNom: nomCapa,
									popupData:html,
									feature: latlng.feature,
									data: latlng.feature.properties
								};
								var tipus = feature.geometry.type; 
								if (tipus != 'Point'){
										latlng.on('click', function(e) {
											createPopupMapaUrlFile(latlng, e);
									});
								}
								return latlng;
							},			  
							middleware:function(data){
								if(data.status && data.status.indexOf("ERROR")!=-1){
									processFileError(data, urlFile);
									jQuery('#info_uploadFile').hide();
								}else{
									var stringData = JSON.stringify(data);
									var geometryType = defineGeometryType(stringData);

									if(geometryType.indexOf("point")!=-1){
										capaURLfile.options.style = estil_do;
									}else if(geometryType.indexOf("line")!=-1){
										capaURLfile.options.style = lineStyle;
									}else if(geometryType.indexOf("polygon")!=-1){
										capaURLfile.options.style = polygonStyle;
									}
									try{
										capaURLfile.addData(data);
									}catch(err){
										console.debug(err);
									}
									
									var llista_options = '{"tipusFile":"'+tipusFile+
									'","nom":"'+nomCapa+
									'","propName":"'+propName+
									'","url":"'+urlFile+
									'","urlFileOriginal":"'+urlFileHttps+
									'","tipus":"'+t_url_file+
									'","epsgIN":"'+epsgIN+
									'", "geometryType":"'+geometryType+
									'","colX":"'+colX+
									'","colY":"'+colY+
									'", "dinamic":"'+dinamic+
									'", "tipusAcc":"'+tipusAcc+
									'", "tipusCodi":"'+tipusCodi+
									'", "tipusFont":"'+tipusFont+
									'", "nomCampCodi":"'+nomCampCodi+
									'", "campUnic":"'+campUnic+
									'", "camps":"'+camps+
									'", "style":'+JSON.stringify(capaURLfile.options.style)+
									'", "separador":"'+separadorCamps+
									',"estil_do":{"radius":"'+estil_do.radius+'","fillColor":"'+estil_do.fillColor+'","color":"'+estil_do.color+'","weight":"'+estil_do.weight+'","opacity":"'+estil_do.opacity+'","fillOpacity":"'+estil_do.fillOpacity+'","isCanvas":"'+estil_do.isCanvas+'","codiUnic":"'+estil_do.codiUnic+'"}}';

									//Un cop tinc la capa a client, la creo a servidor
									var order = 0;
									if(controlCapes){
										order = controlCapes._lastZIndex+1;
									}
									if (urlFile.indexOf("https")>-1 && urlFile.indexOf("csv")>-1) {
										urlFile = urlFileHttps;
									}
									var data = {
										uid:Cookies.get('uid'),
										mapBusinessId: url('?businessid'),
										serverName: nomCapa,//+' '+ (parseInt(controlCapes._lastZIndex) + 1),
										serverType: t_url_file,
										calentas: false,
										activas: true,
										visibilitats: true,
										order: order,
										epsg: '4326',
										imgFormat: 'image/png',
										infFormat: 'text/html',
										tiles: true,	            
										transparency: true,
										opacity: 1,
										visibilitat: 'O',
										url: urlFile,//Provar jQuery("#txt_URLJSON")
										calentas: false,
										activas: true,
										visibilitats: true,
										options: llista_options
									};
									
									createServidorInMap(data).then(function(results){
										jQuery('#info_uploadFile').hide();
										if (results.status == "OK"){
											window.dataLayer.push({
												'event': 'externalLoadedOK',
												'file_url': urlFile,
												'dinamic': true
											});
											//$.publish('analyticsEvent',{event:['mapa', tipus_user+'dades externes dinamiques', urlFile, 1]});

											jQuery('#dialog_dades_ex').modal('hide');					

											capaURLfile.options.businessId = results.results.businessId;
											capaURLfile.options.nom = nomCapa;
											capaURLfile.options.tipus = t_url_file;
											capaURLfile.options.url = urlFile;
											capaURLfile.options.epsgIN = epsgIN;
											capaURLfile.options.tipusFile = tipusFile;
											capaURLfile.options.options = jQuery.parseJSON('{"tipusFile":"'+tipusFile+'"}');
											capaURLfile.options.options.estil_do = estil_do;
											capaURLfile.options.geometryType = geometryType;
											capaURLfile.options.colX = colX;
											capaURLfile.options.colY = colY;
											capaURLfile.options.colWKT = colWKT;
											capaURLfile.options.dinamic = dinamic;
											capaURLfile.options.propName = propName;
											capaURLfile.options.tipusAcc = tipusAcc;
											capaURLfile.options.tipusCodi = tipusCodi;
											capaURLfile.options.tipusFont = tipusFont;
											capaURLfile.options.nomCampCodi = nomCampCodi;
											capaURLfile.options.separador = separadorCamps;
											if (urlFileHttps!=undefined ) {
												capaURLfile.options.urlFileOriginal =urlFileHttps;
											}

											capaURLfile.addTo(map);
											if(controlCapes){
												capaURLfile.options.zIndex = controlCapes._lastZIndex+1; 
												controlCapes.addOverlay(capaURLfile, nomCapa, true);
												controlCapes._lastZIndex++;
											}
											var bounds = capaURLfile.getBounds();
											map.fitBounds(bounds);
											$('#dialog_dades_ex').modal('hide');
											$('#dialog_carrega_dades').modal('hide');
											controlCapes.forceUpdate(true);
											InstamapsUtils.Mapa.activaPanelCapes(true, jQuery);
											if(InstamapsUtils.Validator.isModeMapa($(location).attr('href'))){
												updateSortablesElements();
											}	

										}else{
											window.dataLayer.push({
												'event': 'externalLoadedKO',
												'file_url': urlFile,
												'dinamic': true
											});
											console.debug("1.Error a createServidorInMap:"+results.status);
											$.publish('analyticsEvent',{event:['mapa', tipus_user+'dades externes dinamiques error createServidorInMap1', urlFile, 1]});
											var txt_error = window.lang.translate("Error durant la càrrega de dades. Torni a intentar-ho");
											jQuery("#div_url_file_message").html(txt_error);							
										}
									},function(results){
										console.debug("2.Error a createServidorInMap:"+results.status);
										//$.publish('analyticsEvent',{event:['mapa', tipus_user+'dades externes dinamiques error createServidorInMap2', urlFile, 1]});
										var txt_error = window.lang.translate("Error durant la càrrega de dades. Torni a intentar-ho");
										jQuery("#div_url_file_message").html(txt_error);
										jQuery('#info_uploadFile').hide();

									});
								}
							}
						});	
					}
					
				});
			 });
			
			//console.debug(L.toGeoJSON.geoJsonData);
		}
		else{
		
		$('#dialog_dades_ex').modal('hide');
		$('#dialog_carrega_dades').modal('hide');
		jQuery("#div_uploading_txt").html("");
		jQuery("#div_uploading_txt").html('<div id="div_upload_step1" class="status_current" lang="ca"> '+
				window.lang.translate('Carregant dades')+
		'<span class="one">.</span><span class="two">.</span><span class="three">.</span></div>');		
		jQuery('#info_uploadFile').show();




	   if (param_url.indexOf("/opt/")>-1 || param_url.indexOf("\\temp\\")>-1 ){
		    if (param_url.indexOf("\\temp\\")>-1)  urlFile=HOST_HTTP+"/jsonfiles/"+param_url.substring(param_url.lastIndexOf("\\")+1,param_url.length);
		    else  urlFile=HOST_HTTP+"/jsonfiles/"+param_url.substring(param_url.lastIndexOf("/")+1,param_url.length);
			param_url = paramUrl.urlFileDin	+"tipusFile=" + ".geojson"+
			"&tipusAcc="+tipusAcc+
			"&tipusCodi="+tipusCodi+
			"&tipusFont="+tipusFont+
			"&nomCampCodi="+nomCampCodi+
			"&urlFile="+encodeURIComponent(urlFile)+
			"&epsgIN="+epsgIN+
			"&dinamic="+dinamic+
			"&uploadFile="+paramUrl.uploadFile+
			"&colX="+colX+
			"&colY="+colY+
			"&colWKT="+colWKT+
			"&campUnic="+campUnic+
			"&camps="+camps+
			//"&colXY="+colXY+
			"&uid="+Cookies.get('uid')+
			"&separador="+separadorCamps;		
		}
		
		if (urlFile.indexOf("jsonfiles")>-1) {
			param_url = urlFile;
			if (param_url.indexOf("https")==-1 && urlApp.indexOf("geocat1")==-1 && urlFile.indexOf("dropbox")==-1 &&  urlFile.indexOf("analisi.transparenciacatalunya.cat/")==-1) param_url = param_url.replace("http","https");//modifiquem https
		}

		var capaURLfile = new L.GeoJSON.AJAX(param_url, {
			nom : nomCapa,
			tipus : t_url_file,
			estil_do: estil_do,
			style: estil_lin_pol,//Estil de poligons i linies
			pointToLayer : function(feature, latlng) {
				var geom = L.circleMarker(latlng, estil_do);
				var pp = feature.properties;
				var html ='<div class="div_popup_visor"><div class="popup_pres">';
				propName = "";
				$.each( pp, function( key, value ) {
					propName = propName+key+",";
					if(InstamapsUtils.Validator.isValidValueNotWKT(value)){
						if ( key != 'businessId' && key != 'slotd50'  && key.toLowerCase()!="nomcapa" && key.toLowerCase()!="popupdata" &&
								key.toLowerCase()!="capanom" && key.toLowerCase()!="propname"){
							 		html += InstamapsUtils.Dom.getHtmlFromTxt(value,key);			
						}
					}
				});	
				propName = propName.substr(0, propName.length-1);
				html+='</div></div>'; 
				feature.properties.capaNom=nomCapa;
				feature.properties.popupData=html;
				geom.on('click', function(e) {
					createPopupMapaUrlFile(feature, e);
				});
				

				return geom;
			},
			onEachFeature : function(feature, latlng) {
				var pp = feature.properties;
				var html ='<div class="div_popup_visor"><div class="popup_pres">';
				propName = "";
				$.each( pp, function( key, value ) {
					propName = propName+key+",";
					if(InstamapsUtils.Validator.isValidValueNotWKT(value)){
						if ( key != 'businessId' && key != 'slotd50'  && key.toLowerCase()!="nomcapa" && key.toLowerCase()!="popupdata" &&
								key.toLowerCase()!="capanom" && key.toLowerCase()!="propname"){
									html += InstamapsUtils.Dom.getHtmlFromTxt(value,key);			
						}
					}
				});	
				propName = propName.substr(0, propName.length-1);
				html+='</div></div>'; 
				//latlng.feature.properties.capaNom = nomCapa;
				//latlng.feature.properties.popupData=html;
				latlng.properties={
					capaNom: nomCapa,
					popupData:html,
					feature: latlng.feature,
					data: latlng.feature.properties
				};
				var tipus=feature.geometry.type;
				if (tipus != 'Point'){
					latlng.on('click', function(e) {
						createPopupMapaUrlFile(latlng, e);
					});
				}
				return latlng;
			},			  
			middleware:function(data){
				if(data.status && data.status.indexOf("ERROR")!=-1){
					processFileError(data, urlFile);
					jQuery('#info_uploadFile').hide();
				}else{
					var stringData = JSON.stringify(data);
					var geometryType = defineGeometryType(stringData);

					if (geometryType === undefined) {
						console.debug("2.Error en las geometrias:");
						//$.publish('analyticsEvent',{event:['mapa', tipus_user+'dades externes dinamiques error createServidorInMap2', urlFile, 1]});
						var txt_error = window.lang.translate("Error durant la càrrega de dades. Geometries incorrectes");
						jQuery("#div_url_file_message").html(txt_error).show();
						jQuery('#info_uploadFile').hide();
						$('#dialog_dades_ex').modal('show');
						return;
					}

					if(geometryType.indexOf("point")!=-1){
						capaURLfile.options.style = estil_do;
					}else if(geometryType.indexOf("line")!=-1){
						capaURLfile.options.style = lineStyle;
					}else if(geometryType.indexOf("polygon")!=-1){
						capaURLfile.options.style = polygonStyle;
					}
					try{
						capaURLfile.addData(data);
					}catch(err){
						console.debug(err);
					}
					
					//Un cop tinc la capa a client, la creo a servidor
					if (urlFile.indexOf("https")>-1 && urlFile.indexOf("csv")>-1) {
						urlFile = urlFileHttps;
					}
					
					var llista_options = '{"tipusFile":"'+tipusFile+
					'","nom":"'+nomCapa+
					'","propName":"'+propName+
					'","url":"'+urlFile+
					'","tipus":"'+t_url_file+
					'","epsgIN":"'+epsgIN+
					'", "geometryType":"'+geometryType+
					'","colX":"'+colX+
					'","colY":"'+colY+
					'","colWKT":"'+colWKT+
					'", "dinamic":"'+dinamic+
					'", "tipusAcc":"'+tipusAcc+
					'", "tipusCodi":"'+tipusCodi+
					'", "tipusFont":"'+tipusFont+
					'", "nomCampCodi":"'+nomCampCodi+
					'", "separador":"'+separadorCamps+
					'", "campUnic":"'+campUnic+
					'", "camps":"'+camps+
					'", "style":'+JSON.stringify(capaURLfile.options.style)+
					',"estil_do":{"radius":"'+estil_do.radius+'","fillColor":"'+estil_do.fillColor+'","color":"'+estil_do.color+'","weight":"'+estil_do.weight+'","opacity":"'+estil_do.opacity+'","fillOpacity":"'+estil_do.fillOpacity+'","isCanvas":"'+estil_do.isCanvas+'","codiUnic":"'+estil_do.codiUnic+'"}}';

					//Un cop tinc la capa a client, la creo a servidor
					var order = 0; 
					if(controlCapes){
						order = controlCapes._lastZIndex+1;
					}

					var data = {
						uid:Cookies.get('uid'),
						mapBusinessId: url('?businessid'),
						serverName: nomCapa,//+' '+ (parseInt(controlCapes._lastZIndex) + 1),
						serverType: t_url_file,
						calentas: false,
						activas: true,
						visibilitats: true,
						order: order,
						epsg: '4326',
						imgFormat: 'image/png',
						infFormat: 'text/html',
						tiles: true,	            
						transparency: true,
						opacity: 1,
						visibilitat: 'O',
						url: urlFile,//Provar jQuery("#txt_URLJSON")
						calentas: false,
						activas: true,
						visibilitats: true,
						options: llista_options
					};
					
					createServidorInMap(data).then(function(results){
						jQuery('#info_uploadFile').hide();
						if (results.status == "OK"){
							//$.publish('analyticsEvent',{event:['mapa', tipus_user+'dades externes dinamiques', urlFile, 1]});
							window.dataLayer.push({
								'event': 'externalLoadedOK',
								'file_url': urlFile,
								'dinamic': true
							});
							jQuery('#dialog_dades_ex').modal('hide');					

							capaURLfile.options.businessId = results.results.businessId;
							capaURLfile.options.nom = nomCapa;
							capaURLfile.options.tipus = t_url_file;
							capaURLfile.options.url = urlFile;
							capaURLfile.options.epsgIN = epsgIN;
							capaURLfile.options.tipusFile = tipusFile;
							capaURLfile.options.options = jQuery.parseJSON('{"tipusFile":"'+tipusFile+'"}');
							capaURLfile.options.options.estil_do = estil_do;
							capaURLfile.options.geometryType = geometryType;
							capaURLfile.options.colX = colX;
							capaURLfile.options.colY = colY;
							capaURLfile.options.colWKT = colWKT;
							capaURLfile.options.dinamic = dinamic;
							capaURLfile.options.propName = propName;
							capaURLfile.options.tipusAcc = tipusAcc;
							capaURLfile.options.tipusCodi = tipusCodi;
							capaURLfile.options.tipusFont = tipusFont;
							capaURLfile.options.nomCampCodi = nomCampCodi;
							capaURLfile.options.separador = separadorCamps;
							if (urlFileHttps!=undefined ) {
								capaURLfile.options.urlFileOriginal =urlFileHttps;
							}
							capaURLfile.addTo(map);
							if(controlCapes){
								capaURLfile.options.zIndex = controlCapes._lastZIndex+1; 
								controlCapes.addOverlay(capaURLfile, nomCapa, true);
								controlCapes._lastZIndex++;
							}
							var bounds = capaURLfile.getBounds();
							map.fitBounds(bounds);
							$('#dialog_dades_ex').modal('hide');
							$('#dialog_carrega_dades').modal('hide');
							controlCapes.forceUpdate(true);
							InstamapsUtils.Mapa.activaPanelCapes(true, jQuery);
							if(InstamapsUtils.Validator.isModeMapa($(location).attr('href'))){
								updateSortablesElements();
							}	
							if (codiMsg!==undefined && codiMsg=="12"){
								var msg = "[12]: " + window.lang.translate("Aquest arxiu sobrepassa els 30.000 punts o 10.000 línies o polígons, les geometries que conté no seran inserides a la base de dades sinó consumides com un arxiu en el servidor (endpoint). Per saber-ne més  ")+"<a href='https://betaportal.icgc.cat/wordpress/faq-dinstamaps/#volum' target='_blank'>FAQ 64.</a>";
								$('#dialog_error_upload_txt').html(msg);
								$('#dialog_error_upload').modal('show');
							}

						}else{
							
							window.dataLayer.push({
							'event': 'externalLoadedKO',
							'file_url': urlFile,
							'dinamic': true
							});							
							console.debug("1.Error a createServidorInMap:"+results.status);
							//$.publish('analyticsEvent',{event:['mapa', tipus_user+'dades externes dinamiques error createServidorInMap1', urlFile, 1]});
							var txt_error = window.lang.translate("Error durant la càrrega de dades. Torni a intentar-ho");
							jQuery("#div_url_file_message").html(txt_error);							
						}
					},function(results){
						console.debug("2.Error a createServidorInMap:"+results.status);
						//$.publish('analyticsEvent',{event:['mapa', tipus_user+'dades externes dinamiques error createServidorInMap2', urlFile, 1]});
						var txt_error = window.lang.translate("Error durant la càrrega de dades. Torni a intentar-ho");
						jQuery("#div_url_file_message").html(txt_error);
						jQuery('#info_uploadFile').hide();

					});
				}
			}
		});		
		}
	/*** NO DINAMICA ***/		
	}else{
		var dataSocrata;
		var isJson=false;
		if (tipusFile==".json"){
			isJson=true;
			L.toGeoJSON.empty();
			L.toGeoJSON.convert(urlFile,"Point",colX,colY, colXY, separador).then(function(){
				 dataSocrata={
							serverName: nomCapa,
							jsonSocrata: JSON.stringify(L.toGeoJSON.geoJsonData)
					};
				 
				 crearFitxerSocrata(dataSocrata).then(function(results){
						if (results.status="OK"){
							urlFile =results.filePath;
							var midaFitxer = results.midaFitxer;
							var tmpFilePath = results.tmpFilePath;
							var tmpFileName = results.tmpFileName;
							
							var data2 = {
									uid: Cookies.get('uid'),
									mapBusinessId: url('?businessid'),
									serverName:nomCapa,
									path:urlFile,
									tmpFilePath:tmpFilePath,
									midaFitxer:midaFitxer,
									sourceExtension:'geojson',
									markerStyle: JSON.stringify(getMarkerRangFromStyle(defaultPunt)),
									lineStyle: JSON.stringify(getLineRangFromStyle(InstamapsUtils.Styles.getLineStyleFromToolbar("cv_linia", InstamapsConstants))),
									polygonStyle: JSON.stringify(getPolygonRangFromStyle(InstamapsUtils.Styles.getPolygonStyleFromToolbar("cv_pol", InstamapsConstants)))
								};
															
							
							
								$('#dialog_dades_ex').modal('hide');
								$('#dialog_carrega_dades').modal('hide');

								jQuery("#div_uploading_txt").html("");
								jQuery("#div_uploading_txt").html(
									'<div id="div_upload_step1" class="status_current" lang="ca">1. '+window.lang.translate('Descarregant fitxer')+'<span class="one">.</span><span class="two">.</span><span class="three">.</span></div>'+
									'<div id="div_upload_step2" class="status_uncheck" lang="ca">2. '+window.lang.translate('Analitzant fitxer')+'</div>'+
									'<div id="div_upload_step3" class="status_uncheck" lang="ca">3. '+window.lang.translate('Creant geometries')+'</div>'+
									'<div id="div_upload_step4" class="status_uncheck" lang="ca">4. '+window.lang.translate('Processant la resposta')+'</div>'//+	
								);				
								jQuery('#info_uploadFile').show();			
								jQuery('#info_uploadFile').show();		

								var pollTime = 2000;

								//Fem polling
								(function(){							
									poll = function(){
										$.ajax({
											url: paramUrl.polling +"pollingFileName="+ tmpFileName,
											dataType: 'json',
											type: 'get',
											success: function(data){
												if(data.status.indexOf("PAS2")!=-1){
													jQuery("#div_uploading_txt").html("");
													jQuery("#div_uploading_txt").html(
														'<div id="div_upload_step1" class="status_check" lang="ca">1. '+window.lang.translate('Fitxer descarregat')+' <span class="glyphicon glyphicon-ok" aria-hidden="true"></span></span></div>'+
														'<div id="div_upload_step2" class="status_current" lang="ca">2. '+window.lang.translate('Analitzant fitxer')+'<span class="one">.</span><span class="two">.</span><span class="three">.</div>'+
														'<div id="div_upload_step3" class="status_uncheck" lang="ca">3. '+window.lang.translate('Creant geometries')+'</div>'+
														'<div id="div_upload_step4" class="status_uncheck" lang="ca">4. '+window.lang.translate('Processant la resposta')+'</div>'//+	
													);									
												}else if(data.status.indexOf("PAS3")!=-1){
													jQuery("#div_uploading_txt").html("");
													jQuery("#div_uploading_txt").html(
														'<div id="div_upload_step1" class="status_check" lang="ca">1. '+window.lang.translate('Fitxer descarregat')+' <span class="glyphicon glyphicon-ok" aria-hidden="true"></span></span></div>'+
														'<div id="div_upload_step2" class="status_check" lang="ca">2. '+window.lang.translate('Fitxer analitzat')+' <span class="glyphicon glyphicon-ok" aria-hidden="true"></span></div>'+
														'<div id="div_upload_step3" class="status_current" lang="ca">3. '+window.lang.translate('Creant geometries')+'<span class="one">.</span><span class="two">.</span><span class="three">.</div>'+
														'<div id="div_upload_step4" class="status_uncheck" lang="ca">4. '+window.lang.translate('Processant la resposta')+'</div>'//+	
													);									
												}else if(data.status.indexOf("OK")!=-1){
													clearInterval(pollInterval);
													jQuery("#div_uploading_txt").html("");
													jQuery("#div_uploading_txt").html(
														'<div id="div_upload_step1" class="status_check" lang="ca">1. '+window.lang.translate('Fitxer descarregat')+' <span class="glyphicon glyphicon-ok" aria-hidden="true"></span></span></div>'+
														'<div id="div_upload_step2" class="status_check" lang="ca">2. '+window.lang.translate('Fitxer analitzat')+' <span class="glyphicon glyphicon-ok" aria-hidden="true"></span></div>'+
														'<div id="div_upload_step3" class="status_check" lang="ca">3. '+window.lang.translate('Geometries creades')+' <span class="glyphicon glyphicon-ok" aria-hidden="true"></span></div>'+
														'<div id="div_upload_step4" class="status_current" lang="ca">4. '+window.lang.translate('Processant la resposta')+'<span class="one">.</span><span class="two">.</span><span class="three">.</div>'//+	
													);									
													//$.get(HOST_APP+tmpdirPolling +codiUnic + url('?businessid')+"_response.json", function(data) { 
													//if(data.status.indexOf("OK")!=-1){											
													//addDropFileToMap(data);
														//		}								
													//});
													//$.publish('analyticsEvent',{event:['mapa', tipus_user+'dades externes', urlFile, 1]});
												}else if(data.status.indexOf("ERROR")!=-1){
													console.error("Error al carregar fitxer:");
													console.error(data);
													busy = false;

													clearInterval(pollInterval);
													jQuery('#info_uploadFile').hide();

													$('#dialog_error_upload_txt').html("");

													if(data.codi){

														//$.publish('analyticsEvent',{event:['mapa', tipus_user+'dades externes error '+data.codi, urlFile, 1]});

														if(data.codi.indexOf("01")!=-1){//cas 01: Exception durant el tractament del fitxer
															var msg = "[01]: " + window.lang.translate("Ha ocorregut un error inesperat durant la càrrega del fitxer.");
															$('#dialog_error_upload_txt').html(msg);

														}else if(data.codi.indexOf("02")!=-1){//cas 02: Error durant les conversions de format del fitxer
															var msg = "[02]: " + window.lang.translate("Error durant el procés de conversió de format del fitxer. Comprovi que el fitxer és correcte.");
															$('#dialog_error_upload_txt').html(msg);

														}else if(data.codi.indexOf("03")!=-1){//cas 03: OGRInfo ha donat resposta fallida
															var msg = "[03]: " + window.lang.translate("Error durant l'anàlisi de la informació del fitxer. Comprovi que el fitxer és correcte.");
															$('#dialog_error_upload_txt').html(msg);

														}else if(data.codi.indexOf("04")!=-1){//cas 04: OGRInfo ha donat una excepció
															var msg = "[04]: " + window.lang.translate("Ha ocorregut un error inesperat durant l'anàlisi de la informació del fitxer.");
															$('#dialog_error_upload_txt').html(msg);

														}else if(data.codi.indexOf("05")!=-1){//cas 05: OGRInfo ha tornat resposta buida
															var msg = "[05]: " + window.lang.translate("L'anàlisi de la informació del fitxer no ha tornat resultats. Comprovi el fitxer i torni a intentar-ho.");
															$('#dialog_error_upload_txt').html(msg);

														}else if(data.codi.indexOf("06")!=-1){//cas 06: Accedeix a fileDefault_Error, no li ha arribat be el nom del fitxer
															var msg = "[06]: " + window.lang.translate("Problema de comunicació amb el servidor. Si us plau, torni a intentar-ho.");
															$('#dialog_error_upload_txt').html(msg);

														}else if(data.codi.indexOf("07")!=-1){//cas 07: EnviaFileReady a myUtils.jsp ha donat una excepcio
															var msg = "[07]: " + window.lang.translate("Ha ocorregut un error inesperat durant la comunicació amb el servidor. Si us plau, torni a intentar-ho.");
															$('#dialog_error_upload_txt').html(msg);

														}else if(data.codi.indexOf("08")!=-1){//cas 08: Mida de fitxer supera els 50MB permesos per dades externes dinamiques
															var msg = "[08]: " + window.lang.translate("La mida del fitxer supera el límit preestablert per a dades externes no dinàmiques (50MB).");
															$('#dialog_error_upload_txt').html(msg);
														}

													}else{
														//$.publish('analyticsEvent',{event:['mapa', tipus_user+'dades externes error sense codi', urlFile, 1]});
														$('#dialog_error_upload_txt').html(window.lang.translate("Error en la càrrega de l'arxiu"));
													}

													$('#dialog_error_upload').modal('show');
												}
											}
										});
									};

									pollInterval = setInterval(function(){
										poll();
									},pollTime);

								})();		

								doUploadFile(data2).then(function(results){
									addDropFileToMap(results);
								});
						}
						
					});
			});
		}
		else{
		//console.debug("getUrlFile PROVES NO DINAMICA");
		var codiUnic = InstamapsUtils.Getters.getCodiUnic();
		if (((urlFile.indexOf("socrata")>-1 && (urlFile.indexOf("method=export&format=GeoJSON")>-1 || 
			  urlFile.indexOf("https")>-1))  && urlFile.indexOf("drive")==-1  && (urlFile.indexOf("spreadsheet")==-1) 
			  && urlFile.indexOf("dropbox")==-1) || isJson) 	{
			
			if (isJson==false){
				var response = $.ajax({ type: "GET",   
		            url: urlFile,   
		            async: false
		          }).responseText;
				
				
				 dataSocrata={
						serverName: nomCapa,
						jsonSocrata: response
				};
			}
			
			crearFitxerSocrata(dataSocrata).then(function(results){
				if (results.status="OK"){
					urlFile =results.filePath;
					var midaFitxer = results.midaFitxer;
					var tmpFilePath = results.tmpFilePath;
					var tmpFileName = results.tmpFileName;
					
					var data2 = {
							uid: Cookies.get('uid'),
							mapBusinessId: url('?businessid'),
							serverName:nomCapa,
							path:urlFile,
							tmpFilePath:tmpFilePath,
							midaFitxer:midaFitxer,
							sourceExtension:'geojson',
							markerStyle: JSON.stringify(getMarkerRangFromStyle(defaultPunt)),
							lineStyle: JSON.stringify(getLineRangFromStyle(InstamapsUtils.Styles.getLineStyleFromToolbar("cv_linia", InstamapsConstants))),
							polygonStyle: JSON.stringify(getPolygonRangFromStyle(InstamapsUtils.Styles.getPolygonStyleFromToolbar("cv_pol", InstamapsConstants)))
						};
													
					
					
						$('#dialog_dades_ex').modal('hide');
						$('#dialog_carrega_dades').modal('hide');

						jQuery("#div_uploading_txt").html("");
						jQuery("#div_uploading_txt").html(
							'<div id="div_upload_step1" class="status_current" lang="ca">1. '+window.lang.translate('Descarregant fitxer')+'<span class="one">.</span><span class="two">.</span><span class="three">.</span></div>'+
							'<div id="div_upload_step2" class="status_uncheck" lang="ca">2. '+window.lang.translate('Analitzant fitxer')+'</div>'+
							'<div id="div_upload_step3" class="status_uncheck" lang="ca">3. '+window.lang.translate('Creant geometries')+'</div>'+
							'<div id="div_upload_step4" class="status_uncheck" lang="ca">4. '+window.lang.translate('Processant la resposta')+'</div>'//+	
						);				
						jQuery('#info_uploadFile').show();			
						jQuery('#info_uploadFile').show();		

						var pollTime = 2000;

						//Fem polling
						(function(){							
							poll = function(){
								$.ajax({
									url: paramUrl.polling +"pollingFileName="+ tmpFileName,
									dataType: 'json',
									type: 'get',
									success: function(data){
										if(data.status.indexOf("PAS2")!=-1){
											jQuery("#div_uploading_txt").html("");
											jQuery("#div_uploading_txt").html(
												'<div id="div_upload_step1" class="status_check" lang="ca">1. '+window.lang.translate('Fitxer descarregat')+' <span class="glyphicon glyphicon-ok" aria-hidden="true"></span></span></div>'+
												'<div id="div_upload_step2" class="status_current" lang="ca">2. '+window.lang.translate('Analitzant fitxer')+'<span class="one">.</span><span class="two">.</span><span class="three">.</div>'+
												'<div id="div_upload_step3" class="status_uncheck" lang="ca">3. '+window.lang.translate('Creant geometries')+'</div>'+
												'<div id="div_upload_step4" class="status_uncheck" lang="ca">4. '+window.lang.translate('Processant la resposta')+'</div>'//+	
											);									
										}else if(data.status.indexOf("PAS3")!=-1){
											jQuery("#div_uploading_txt").html("");
											jQuery("#div_uploading_txt").html(
												'<div id="div_upload_step1" class="status_check" lang="ca">1. '+window.lang.translate('Fitxer descarregat')+' <span class="glyphicon glyphicon-ok" aria-hidden="true"></span></span></div>'+
												'<div id="div_upload_step2" class="status_check" lang="ca">2. '+window.lang.translate('Fitxer analitzat')+' <span class="glyphicon glyphicon-ok" aria-hidden="true"></span></div>'+
												'<div id="div_upload_step3" class="status_current" lang="ca">3. '+window.lang.translate('Creant geometries')+'<span class="one">.</span><span class="two">.</span><span class="three">.</div>'+
												'<div id="div_upload_step4" class="status_uncheck" lang="ca">4. '+window.lang.translate('Processant la resposta')+'</div>'//+	
											);									
										}else if(data.status.indexOf("OK")!=-1){
											clearInterval(pollInterval);
											jQuery("#div_uploading_txt").html("");
											jQuery("#div_uploading_txt").html(
												'<div id="div_upload_step1" class="status_check" lang="ca">1. '+window.lang.translate('Fitxer descarregat')+' <span class="glyphicon glyphicon-ok" aria-hidden="true"></span></span></div>'+
												'<div id="div_upload_step2" class="status_check" lang="ca">2. '+window.lang.translate('Fitxer analitzat')+' <span class="glyphicon glyphicon-ok" aria-hidden="true"></span></div>'+
												'<div id="div_upload_step3" class="status_check" lang="ca">3. '+window.lang.translate('Geometries creades')+' <span class="glyphicon glyphicon-ok" aria-hidden="true"></span></div>'+
												'<div id="div_upload_step4" class="status_current" lang="ca">4. '+window.lang.translate('Processant la resposta')+'<span class="one">.</span><span class="two">.</span><span class="three">.</div>'//+	
											);	
											window.dataLayer.push({
												'event': 'externalLoadedOK',
												'file_url': urlFile,
												'dinamic': false
											});								
											//$.get(HOST_APP+tmpdirPolling +codiUnic + url('?businessid')+"_response.json", function(data) { 
											//if(data.status.indexOf("OK")!=-1){											
											//addDropFileToMap(data);
												//		}								
											//});
											//$.publish('analyticsEvent',{event:['mapa', tipus_user+'dades externes', urlFile, 1]});
										}else if(data.status.indexOf("ERROR")!=-1){
											console.error("Error al carregar fitxer:");
											console.error(data);
											busy = false;

											window.dataLayer.push({
												'event': 'externalLoadedKO',
												'file_url': urlFile,
												'dinamic': false
											});											clearInterval(pollInterval);
											jQuery('#info_uploadFile').hide();

											$('#dialog_error_upload_txt').html("");

											if(data.codi){

												//$.publish('analyticsEvent',{event:['mapa', tipus_user+'dades externes error '+data.codi, urlFile, 1]});

												if(data.codi.indexOf("01")!=-1){//cas 01: Exception durant el tractament del fitxer
													var msg = "[01]: " + window.lang.translate("Ha ocorregut un error inesperat durant la càrrega del fitxer.");
													$('#dialog_error_upload_txt').html(msg);

												}else if(data.codi.indexOf("02")!=-1){//cas 02: Error durant les conversions de format del fitxer
													var msg = "[02]: " + window.lang.translate("Error durant el procés de conversió de format del fitxer. Comprovi que el fitxer és correcte.");
													$('#dialog_error_upload_txt').html(msg);

												}else if(data.codi.indexOf("03")!=-1){//cas 03: OGRInfo ha donat resposta fallida
													var msg = "[03]: " + window.lang.translate("Error durant l'anàlisi de la informació del fitxer. Comprovi que el fitxer és correcte.");
													$('#dialog_error_upload_txt').html(msg);

												}else if(data.codi.indexOf("04")!=-1){//cas 04: OGRInfo ha donat una excepció
													var msg = "[04]: " + window.lang.translate("Ha ocorregut un error inesperat durant l'anàlisi de la informació del fitxer.");
													$('#dialog_error_upload_txt').html(msg);

												}else if(data.codi.indexOf("05")!=-1){//cas 05: OGRInfo ha tornat resposta buida
													var msg = "[05]: " + window.lang.translate("L'anàlisi de la informació del fitxer no ha tornat resultats. Comprovi el fitxer i torni a intentar-ho.");
													$('#dialog_error_upload_txt').html(msg);

												}else if(data.codi.indexOf("06")!=-1){//cas 06: Accedeix a fileDefault_Error, no li ha arribat be el nom del fitxer
													var msg = "[06]: " + window.lang.translate("Problema de comunicació amb el servidor. Si us plau, torni a intentar-ho.");
													$('#dialog_error_upload_txt').html(msg);

												}else if(data.codi.indexOf("07")!=-1){//cas 07: EnviaFileReady a myUtils.jsp ha donat una excepcio
													var msg = "[07]: " + window.lang.translate("Ha ocorregut un error inesperat durant la comunicació amb el servidor. Si us plau, torni a intentar-ho.");
													$('#dialog_error_upload_txt').html(msg);

												}else if(data.codi.indexOf("08")!=-1){//cas 08: Mida de fitxer supera els 50MB permesos per dades externes dinamiques
													var msg = "[08]: " + window.lang.translate("La mida del fitxer supera el límit preestablert per a dades externes no dinàmiques (50MB).");
													$('#dialog_error_upload_txt').html(msg);
												}

											}else{
												//$.publish('analyticsEvent',{event:['mapa', tipus_user+'dades externes error sense codi', urlFile, 1]});
												$('#dialog_error_upload_txt').html(window.lang.translate("Error en la càrrega de l'arxiu"));
											}

											$('#dialog_error_upload').modal('show');
										}
									}
								});
							};

							pollInterval = setInterval(function(){
								poll();
							},pollTime);

						})();		

						doUploadFile(data2).then(function(results){
							addDropFileToMap(results);
						});
				}
				
			});
		}
		else {
			if (urlFile.indexOf("https")>-1 && urlFile.indexOf("csv")>-1 && tipusFile!=".json" && urlFile.indexOf("dropbox")==-1){//} || (urlFile.indexOf("spreadsheets")>-1)) {
				if (urlFile.indexOf("https")>-1) {
					var HOST_APP4 = "http://www.instamaps.cat/";
					if (urlApp.indexOf("geocat1")>-1 || urlApp.indexOf("localhost")>-1)  HOST_APP4=HOST_APP3;	 			
					urlFile = HOST_APP4+paramUrl.proxy_betterWMS + "?url="+urlFile;
				}
				else {
					//if (urlFile.indexOf("instamaps.cat")==-1 && urlFile.indexOf("https")>-1 && urlFile.indexOf("dropbox")==-1 && urlFile.indexOf("sharepoint")==-1) urlFile = urlFile.replace("https","http");
				}    
			}
			//if (urlFile.indexOf("spreadsheet")==-1 && urlFile.indexOf("instamaps.cat")==-1 && urlFile.indexOf("https")>-1 && urlFile.indexOf("dropbox")==-1 && urlFile.indexOf("sharepoint")==-1 && urlFile.indexOf("analisi.transparenciacatalunya.cat/")==-1) urlFile = urlFile.replace("https","http");
			if (urlFile.indexOf("sharepoint")>-1){
				urlFile = urlFile+"&download=1";
			}
			if (urlApp.indexOf("geocat1")>-1)  urlFile = urlFile.replace("https","http");
			
			var data = {
					mapBusinessId: url('?businessid'),
					serverName: nomCapa,
					tipusFile: tipusFile,
					urlFile: urlFile,
					epsgIN: epsgIN,
					dinamic: dinamic,
					uploadFile: paramUrl.uploadFile,
					uid: Cookies.get('uid'),
					colX: colX,
					colY: colY,
					tipusAcc: tipusAcc,
					tipusFont: tipusFont,
					tipusCodi: tipusCodi,
					nomCampCodi: nomCampCodi,
					codiUnic: codiUnic,
					separador: separadorCamps,
					campUnic: campUnic,
					camps: camps,
					markerStyle: JSON.stringify(getMarkerRangFromStyle(defaultPunt)),
					lineStyle: JSON.stringify(getLineRangFromStyle(InstamapsUtils.Styles.getLineStyleFromToolbar("cv_linia", InstamapsConstants))),
					polygonStyle: JSON.stringify(getPolygonRangFromStyle(InstamapsUtils.Styles.getPolygonStyleFromToolbar("cv_pol", InstamapsConstants)))
				};

						
				
				$('#dialog_dades_ex').modal('hide');
				$('#dialog_carrega_dades').modal('hide');

				jQuery("#div_uploading_txt").html("");
				jQuery("#div_uploading_txt").html(
					'<div id="div_upload_step1" class="status_current" lang="ca">1. '+window.lang.translate('Descarregant fitxer')+'<span class="one">.</span><span class="two">.</span><span class="three">.</span></div>'+
					'<div id="div_upload_step2" class="status_uncheck" lang="ca">2. '+window.lang.translate('Analitzant fitxer')+'</div>'+
					'<div id="div_upload_step3" class="status_uncheck" lang="ca">3. '+window.lang.translate('Creant geometries')+'</div>'+
					'<div id="div_upload_step4" class="status_uncheck" lang="ca">4. '+window.lang.translate('Processant la resposta')+'</div>'//+	
				);				
				jQuery('#info_uploadFile').show();			
				jQuery('#info_uploadFile').show();		

				var pollTime = 2000;

				//Fem polling
				(function(){							
					poll = function(){
						$.ajax({
							url: paramUrl.polling +"pollingFileName="+ codiUnic + url('?businessid')+".json",
							dataType: 'json',
							type: 'get',
							success: function(data){
								if(data.status.indexOf("PAS2")!=-1){
									jQuery("#div_uploading_txt").html("");
									jQuery("#div_uploading_txt").html(
										'<div id="div_upload_step1" class="status_check" lang="ca">1. '+window.lang.translate('Fitxer descarregat')+' <span class="glyphicon glyphicon-ok" aria-hidden="true"></span></span></div>'+
										'<div id="div_upload_step2" class="status_current" lang="ca">2. '+window.lang.translate('Analitzant fitxer')+'<span class="one">.</span><span class="two">.</span><span class="three">.</div>'+
										'<div id="div_upload_step3" class="status_uncheck" lang="ca">3. '+window.lang.translate('Creant geometries')+'</div>'+
										'<div id="div_upload_step4" class="status_uncheck" lang="ca">4. '+window.lang.translate('Processant la resposta')+'</div>'//+	
									);									
								}else if(data.status.indexOf("PAS3")!=-1){
									jQuery("#div_uploading_txt").html("");
									jQuery("#div_uploading_txt").html(
										'<div id="div_upload_step1" class="status_check" lang="ca">1. '+window.lang.translate('Fitxer descarregat')+' <span class="glyphicon glyphicon-ok" aria-hidden="true"></span></span></div>'+
										'<div id="div_upload_step2" class="status_check" lang="ca">2. '+window.lang.translate('Fitxer analitzat')+' <span class="glyphicon glyphicon-ok" aria-hidden="true"></span></div>'+
										'<div id="div_upload_step3" class="status_current" lang="ca">3. '+window.lang.translate('Creant geometries')+'<span class="one">.</span><span class="two">.</span><span class="three">.</div>'+
										'<div id="div_upload_step4" class="status_uncheck" lang="ca">4. '+window.lang.translate('Processant la resposta')+'</div>'//+	
									);									
								}else if(data.status.indexOf("OK")!=-1){
									clearInterval(pollInterval);
									jQuery("#div_uploading_txt").html("");
									jQuery("#div_uploading_txt").html(
										'<div id="div_upload_step1" class="status_check" lang="ca">1. '+window.lang.translate('Fitxer descarregat')+' <span class="glyphicon glyphicon-ok" aria-hidden="true"></span></span></div>'+
										'<div id="div_upload_step2" class="status_check" lang="ca">2. '+window.lang.translate('Fitxer analitzat')+' <span class="glyphicon glyphicon-ok" aria-hidden="true"></span></div>'+
										'<div id="div_upload_step3" class="status_check" lang="ca">3. '+window.lang.translate('Geometries creades')+' <span class="glyphicon glyphicon-ok" aria-hidden="true"></span></div>'+
										'<div id="div_upload_step4" class="status_current" lang="ca">4. '+window.lang.translate('Processant la resposta')+'<span class="one">.</span><span class="two">.</span><span class="three">.</div>'//+	
									);									
									$.get(HOST_APP+tmpdirPolling +codiUnic + url('?businessid')+"_response.json", function(data) { 
										if(data.status.indexOf("OK")!=-1){											
											addDropFileToMap(data);
										}								
									});
									window.dataLayer.push({
										'event': 'externalLoadedOK',
										'file_url': urlFile,
										'dinamic': false
									});
									//$.publish('analyticsEvent',{event:['mapa', tipus_user+'dades externes', urlFile, 1]});
								}else if(data.status.indexOf("ERROR")!=-1){
									console.error("Error al carregar fitxer:");
									console.error(data);
									busy = false;
									window.dataLayer.push({
										'event': 'externalLoadedKO',
										'file_url': urlFile,
										'dinamic': false
									});									
									clearInterval(pollInterval);
									jQuery('#info_uploadFile').hide();

									$('#dialog_error_upload_txt').html("");

									if(data.codi){

										//$.publish('analyticsEvent',{event:['mapa', tipus_user+'dades externes error '+data.codi, urlFile, 1]});

										if(data.codi.indexOf("01")!=-1){//cas 01: Exception durant el tractament del fitxer
											var msg = "[01]: " + window.lang.translate("Ha ocorregut un error inesperat durant la càrrega del fitxer.");
											$('#dialog_error_upload_txt').html(msg);

										}else if(data.codi.indexOf("02")!=-1){//cas 02: Error durant les conversions de format del fitxer
											var msg = "[02]: " + window.lang.translate("Error durant el procés de conversió de format del fitxer. Comprovi que el fitxer és correcte.");
											$('#dialog_error_upload_txt').html(msg);

										}else if(data.codi.indexOf("03")!=-1){//cas 03: OGRInfo ha donat resposta fallida
											var msg = "[03]: " + window.lang.translate("Error durant l'anàlisi de la informació del fitxer. Comprovi que el fitxer és correcte.");
											$('#dialog_error_upload_txt').html(msg);

										}else if(data.codi.indexOf("04")!=-1){//cas 04: OGRInfo ha donat una excepció
											var msg = "[04]: " + window.lang.translate("Ha ocorregut un error inesperat durant l'anàlisi de la informació del fitxer.");
											$('#dialog_error_upload_txt').html(msg);

										}else if(data.codi.indexOf("05")!=-1){//cas 05: OGRInfo ha tornat resposta buida
											var msg = "[05]: " + window.lang.translate("L'anàlisi de la informació del fitxer no ha tornat resultats. Comprovi el fitxer i torni a intentar-ho.");
											$('#dialog_error_upload_txt').html(msg);

										}else if(data.codi.indexOf("06")!=-1){//cas 06: Accedeix a fileDefault_Error, no li ha arribat be el nom del fitxer
											var msg = "[06]: " + window.lang.translate("Problema de comunicació amb el servidor. Si us plau, torni a intentar-ho.");
											$('#dialog_error_upload_txt').html(msg);

										}else if(data.codi.indexOf("07")!=-1){//cas 07: EnviaFileReady a myUtils.jsp ha donat una excepcio
											var msg = "[07]: " + window.lang.translate("Ha ocorregut un error inesperat durant la comunicació amb el servidor. Si us plau, torni a intentar-ho.");
											$('#dialog_error_upload_txt').html(msg);

										}else if(data.codi.indexOf("08")!=-1){//cas 08: Mida de fitxer supera els 50MB permesos per dades externes dinamiques
											var msg = "[08]: " + window.lang.translate("La mida del fitxer supera el límit preestablert per a dades externes no dinàmiques (50MB).");
											$('#dialog_error_upload_txt').html(msg);
										}

									}else{
										//$.publish('analyticsEvent',{event:['mapa', tipus_user+'dades externes error sense codi', urlFile, 1]});
										$('#dialog_error_upload_txt').html(window.lang.translate("Error en la càrrega de l'arxiu"));
									}

									$('#dialog_error_upload').modal('show');
								}
							}
						});
					};

					pollInterval = setInterval(function(){
						poll();
					},pollTime);

				})();		

				getUrlFileNoDin(data);
			}
		}
		
	}
}

function processFileError(data, urlFile){

	if(data.codi){

		//$.publish('analyticsEvent',{event:['mapa', tipus_user+'dades externes dinamiques error '+data.codi, urlFile, 1]});
		var txt_error="";
		if(data.codi.indexOf("01")!=-1){//cas 01: Erro al descarregar el fitxer zip (download_zip_file)
			txt_error = "[01]: " + window.lang.translate("Ha ocorregut un error inesperat durant la descàrrega del fitxer.");

		}else if(data.codi.indexOf("02")!=-1){//cas 02: EnviaFileReadyCodiDin a myUtils.jsp ha donat una excepcio
			txt_error = "[02]: " + window.lang.translate("Ha ocorregut un error inesperat durant la comunicació amb el servidor. Si us plau, torni a intentar-ho.");

		}else if(data.codi.indexOf("03")!=-1){//cas 03: Error de conversio del fitxer
			txt_error = "[03]: " + window.lang.translate("Error durant el procés de conversió de format del fitxer. Comprovi que el fitxer és correcte.");
//			$('#dialog_error_upload_txt').html(msg);

		}else if(data.codi.indexOf("04")!=-1){//cas 04: OGRInfo ha donat una excepció
			txt_error = "[04]: " + window.lang.translate("Ha ocorregut un error inesperat durant l'anàlisi de la informació del fitxer.");
//			$('#dialog_error_upload_txt').html(msg);

		}else if(data.codi.indexOf("05")!=-1){//cas 05: OGRInfo ha tornat resposta buida
			txt_error = "[05]: " + window.lang.translate("L'anàlisi de la informació del fitxer no ha tornat resultats. Comprovi el fitxer i torni a intentar-ho.");
//			$('#dialog_error_upload_txt').html(msg);

		}else if(data.codi.indexOf("06")!=-1){//cas 06: OGRInfo ha donat resposta fallida
			txt_error = "[06]: " + window.lang.translate("Error durant l'anàlisi de la informació del fitxer. Comprovi que el fitxer és correcte.");
//			$('#dialog_error_upload_txt').html(msg);

		}else if(data.codi.indexOf("07")!=-1){//cas 07: Num maxim de punts excedit
			txt_error = "[07]: " + window.lang.translate("El número de punts supera el màxim permès. Redueixi a 10000 o menys i torni a intentar-ho");
//			$('#dialog_error_upload_txt').html(msg);

		}else if(data.codi.indexOf("08")!=-1){//cas 08: Num maxim de linies/poligons exedit
			txt_error = "[08]: " + window.lang.translate("El número total de geometries supera el màxim permès. Redueixi a 6000 o menys i torni a intentar-ho.");
//			$('#dialog_error_upload_txt').html(msg);

		}else if(data.codi.indexOf("09")!=-1){//cas 09: Mida de fitxer supera els 25MB permesos per dades externes dinamiques
			txt_error = "[09]: " + window.lang.translate("La mida del fitxer supera el límit preestablert per a dades externes dinàmiques (25MB).");
//			$('#dialog_error_upload_txt').html(msg);
		}			

	}else{
		if(data.results && (data.results.indexOf("EXCEPTION1")  != -1))
			txt_error = window.lang.translate("No s'ha trobat el fitxer: ") + "<a href=\"" + urlFile + "\" target=_blank>" + urlFile + "</a>";
		else
			txt_error = window.lang.translate("Error durant el tractament de les dades");
	}

	/*
	if(data.results.indexOf("CONVERT ERROR")!= -1){
		var txt_error = window.lang.translate("Error de conversió: format o EPSG incorrectes");
	}else if(data.results.indexOf("501")!= -1){//+ de 5000 punts
		txt_error += ": "+window.lang.translate("El número de punts supera el màxim permès. Redueixi a 10000 o menys i torni a intentar-ho");
	}else if(data.results.indexOf("502")!= -1){//+ de 1000 features
		txt_error += ": "+window.lang.translate("El número de línies/polígons supera el màxim permès. Redueixi a 2000 o menys i torni a intentar-ho");
	}else if(data.results.indexOf("503")!= -1){//+ de 6000 geometries
		txt_error += ": "+window.lang.translate("El número total de geometries supera el màxim permès. Redueixi a 6000 o menys i torni a intentar-ho");
	}*/

	//$.publish('analyticsEvent',{event:['mapa', tipus_user+'dades externes error', data.results, 1]});
	$('#dialog_error_upload_txt').html(txt_error);
	$('#dialog_error_upload').modal('show');
}

function loadURLfileLayer(layer,optionsMare){
	
	var defer = $.Deferred();
	PopupManager();
	var options =  InstamapsUtils.Dom.cleanLayerUrlOptions(layer);
	
	//Variables comunes para todos los casos
	var style = options.style;
	if (style === undefined && optionsMare!==undefined) style = optionsMare.style;
	var tipusFile = options.tipusFile;
	if (tipusFile === undefined && optionsMare!==undefined) tipusFile = optionsMare.tipusFile;
	var geometryType = options.geometryType;
	if (geometryType === undefined && optionsMare!==undefined) geometryType = optionsMare.geometryType;
	var epsgIN = options.epsgIN;
	if (epsgIN === undefined && optionsMare!==undefined) epsgIN = optionsMare.epsgIN;
	var colX = options.colX;
	if (colX === undefined && optionsMare!==undefined) colX = optionsMare.colX;
	var colY = options.colY;
	if (colY === undefined && optionsMare!==undefined) colY = optionsMare.colY;
	var colWKT = options.colWKT;
	if (colWKT === undefined && optionsMare!==undefined) colWKT = optionsMare.colWKT;
	var urlFile = layer.url;
	var dinamic = options.dinamic;
	if (dinamic === undefined && optionsMare!==undefined) dinamic = optionsMare.dinamic;

	var tipusAcc = options.tipusAcc;
	if (tipusAcc === undefined && optionsMare!==undefined) tipusAcc = optionsMare.tipusAcc;
	var tipusCodi = options.tipusCodi;
	if (tipusCodi === undefined && optionsMare!==undefined) tipusCodi = optionsMare.tipusCodi;
	var tipusFont = options.tipusFont;
	if (tipusFont === undefined && optionsMare!==undefined) tipusFont = optionsMare.tipusFont;
	var nomCampCodi = options.nomCampCodi;
	if (nomCampCodi === undefined && optionsMare!==undefined) nomCampCodi = optionsMare.nomCampCodi;
	var separador = options.separador;
	if (separador === undefined && optionsMare!==undefined) separador = optionsMare.separador;
	var camps = options.camps;
	if (camps === undefined && optionsMare!==undefined) camps = optionsMare.camps;
	var campUnic = options.campUnic;
	if (campUnic === undefined && optionsMare!==undefined) campUnic = optionsMare.campUnic;
	var origen = options.origen;
	if (origen===undefined && optionsMare!==undefined) origen=optionsMare.businessId;

	var mapBusinessId =  url('?businessid');
	
	if ((urlFile.indexOf("https")>-1 && urlFile.indexOf("csv")>-1 && urlFile.indexOf("spreadsheet")==-1 && tipusFile!=".json") && urlFile.indexOf("dropbox")==-1){// || (urlFile.indexOf("spreadsheets")>-1))  {
		if (urlFile.indexOf("https")>-1 ) {
			urlFile = HOST_HTTP+paramUrl.proxy_betterWMS + "?url="+urlFile;
		}
		else {
			//if (urlFile.indexOf("instamaps.cat")==-1 && urlFile.indexOf("https")>-1 && urlFile.indexOf("dropbox")==-1) urlFile = urlFile.replace("https","http");
		}    
	}

	//if (urlFile.indexOf("spreadsheet")==-1 && urlFile.indexOf("instamaps.cat")==-1 && urlFile.indexOf("https")>-1 && urlFile.indexOf("dropbox")==-1 && urlFile.indexOf("sharepoint")==-1 && urlFile.indexOf("analisi.transparenciacatalunya.cat/")==-1) urlFile = urlFile.replace("https","http");
	if (urlFile.indexOf("geocat1")>-1)  urlFile = urlFile.replace("https","http");
	var tipusTem =  options.tem;
	if (options.tem===undefined){
		try{
			if (options.indexOf("heatmapTematic")>-1) tipusTem=tem_heatmap;
			else if (options.indexOf("clusterTematic")>-1) tipusTem=tem_cluster;
			else if (options.indexOf("sizeTematic")>-1) tipusTem=tem_size;
			else if (options.indexOf("clasicTematic")>-1) tipusTem=tem_clasic;
		}catch(e){

		}
	}
	
	var estil_do = options.estil_do;
	if(tipusTem == tem_heatmap){
		estil_do = InstamapsUtils.Styles.retornaEstilaDO(defaultPunt); //TODO revisar si se puede quitar esto
	}
	
	if (tipusFile==".json") tipusFile=".geojson";
	
	var param_url = paramUrl.urlFileDin +  "tipusFile=" + tipusFile+
		"&mapBusinessId="+mapBusinessId+
		"&colX="+colX+
		"&colY="+colY+
		"&colWKT="+colWKT+
		"&epsgIN="+epsgIN+
		"&dinamic="+dinamic+
		"&campUnic="+campUnic+
		"&camps="+camps+
		"&separador="+separador+
		"&urlFile="+encodeURIComponent(urlFile)+
		"&uploadFile="+paramUrl.uploadFile;
		if ($(location).attr('href').indexOf('/visor.html') != -1 || $(location).attr('href').indexOf('instavisor') != -1) { 
			param_url +="&uid="+_UsrID;
		}
		else {
			param_url +="&uid="+Cookies.get('uid');	
		}
	
	var capaURLfileLoad;
	


	/**
	 * ORIGEN O TEMATIC SIMPLE
	 */	
	if(tipusTem == null || tipusTem == undefined || tipusTem == tem_simple){		


		options.nom = layer.serverName;
		options.businessId = layer.businessId;

		param_url += "&tipusAcc="+tipusAcc+
			"&tipusCodi="+tipusCodi+
			"&tipusFont="+tipusFont+
			"&nomCampCodi="+nomCampCodi+
			"&separador="+separador;

		//SOCRATA	
		if ((urlFile.indexOf("socrata")>-1 || urlFile.indexOf("https")>-1) && (urlFile.indexOf("drive")==-1)  && (urlFile.indexOf("spreadsheet")==-1)
				&& (urlFile.indexOf("dropbox")==-1) && (urlFile.indexOf("csv")==-1) && (urlFile.indexOf("sharepoint")==-1)) 	{
			param_url = urlFile;
		}

		if (urlFile.indexOf("jsonfiles")>-1){
			param_url = urlFile;			
			if (param_url.indexOf("https")==-1  && urlApp.indexOf("geocat1")==-1  && urlApp.indexOf("localhost")==-1 && urlFile.indexOf("dropbox")==-1 && urlFile.indexOf("sharepoint")==-1 && urlFile.indexOf("analisi.transparenciacatalunya.cat/")==-1) param_url = param_url.replace("http","https");
		}
				
		var optionsVis =  options;
		if (optionsVis!=undefined && optionsVis.opcionsVis!=undefined && optionsVis.opcionsVis=="nomesetiqueta"){
			style.opacity=0;
			style.fillOpacity=0;
		}
		capaURLfileLoad = new L.GeoJSON.AJAX(param_url, {
			nom : layer.serverName,
			tipus : layer.serverType,
			geometryType: geometryType,
			businessId : layer.businessId,
			style: style,
			pointToLayer : function(feature, latlng) {
				var pp = feature.properties;
				var geom = L.circleMarker(latlng, estil_do);
				var html ='<div class="div_popup_visor"><div class="popup_pres">';
				$.each( pp, function( key, value ) {
					if(InstamapsUtils.Validator.isValidValueNotWKT(value)){
						if ( key != 'businessId' && key != 'slotd50'  && key.toLowerCase()!="nomcapa" && key.toLowerCase()!="popupdata" &&
								key.toLowerCase()!="capanom" && key.toLowerCase()!="propname"){							
									html += InstamapsUtils.Dom.getHtmlFromTxt(value,key);			
						}
					}
					
				});	
				html+='</div></div>';    	
				html+=PopupManager().createDinamicFooterButtons(feature,options.geometryType,capaURLfileLoad.options.businessId);
				var popup = L.popup().setContent(html);
				if (optionsVis!=undefined && optionsVis.campEtiqueta!=undefined){
					var style = "font-family:"+optionsVis.fontFamily+";font-size:"+optionsVis.fontSize+";color:"+optionsVis.fontColor;
					if (optionsVis.contorn!=undefined && optionsVis.contorn=="si") {
						style+=";text-shadow:1px 1px #ffffff";
					}
					else 	style+=";text-shadow:0px 0px #ffffff";
					if (optionsVis.fontStyle!=undefined){
						if (optionsVis.fontStyle=="normal" || optionsVis.fontStyle=="bold") style+= ";font-weight:"+optionsVis.fontStyle;
						else if (optionsVis.fontStyle=="italic") style+= ";font-style:"+optionsVis.fontStyle;
					}
					if (optionsVis.caixa!=undefined && optionsVis.caixa=="si"){
						style += ";background-color:"+optionsVis.caixaColor;
					}
					else style += ";background-color:transparent";
					style += ";border: 0px;box-shadow: none";
					InstamapsUtils.Dom.createClass('.etiqueta_style_'+layer.businessId,style);
				}
				var zoomInicialEtiqueta = "2";
				if (optionsVis!=undefined && optionsVis.zoomInicial!=undefined) zoomInicialEtiqueta=optionsVis.zoomInicial;
				var zoomFinalEtiqueta = "19";
				if (optionsVis!=undefined && optionsVis.zoomFinal!=undefined)  zoomFinalEtiqueta=optionsVis.zoomFinal;
				if (optionsVis!=undefined && optionsVis.campEtiqueta!=undefined) {
					if (optionsVis!=undefined && optionsVis.opcionsVis!=undefined && 
							(optionsVis.opcionsVis=="nomesetiqueta" || optionsVis.opcionsVis=="etiquetageom") ){
							var permanent = true;
							if (optionsVis.hoverEtiqueta!=undefined) permanent = (optionsVis.hoverEtiqueta!=="hover");	
							geom.bindTooltip(pp[optionsVis.campEtiqueta],
							{opacity:1, permanent: permanent,interactive:true,  direction: 'center',className: "etiqueta_style_"+layer.businessId,offset: [0, 0]});						
					}
					if ((zoomInicialEtiqueta!=undefined && map.getZoom()<zoomInicialEtiqueta) ||
							(zoomFinalEtiqueta!=undefined && map.getZoom() > zoomFinalEtiqueta)) {//ocultem labels
							try{
								if (geom.label!=undefined) geom.label.setOpacity(0);
								else geom.closeTooltip();
							}catch(err){
								
							}
					}
				}
				
				feature.properties.capaNom=layer.serverName;
				feature.properties.popupData=html;
				geom.on('click', function(e) {
					createPopupMapaUrlFile(feature, e);
				});
				
				
				
				return geom;
			},
			onEachFeature : function(feature, latlng) {
				var pp = feature.properties;
				var html ='<div class="div_popup_visor"><div class="popup_pres">';
				$.each( pp, function( key, value ) {
						if(InstamapsUtils.Validator.isValidValueNotWKT(value)){
							if ( key != 'businessId' && key != 'slotd50'  && key.toLowerCase()!="nomcapa" && key.toLowerCase()!="popupdata" &&
									key.toLowerCase()!="capanom" && key.toLowerCase()!="propname"){
										html += InstamapsUtils.Dom.getHtmlFromTxt(value,key);			
							}
						}
					
				});		
				html+='</div></div>';
				html+=PopupManager().createDinamicFooterButtons(feature,options.geometryType,capaURLfileLoad.options.businessId);
				var tipus = feature.geometry.type; 
				if (optionsVis!=undefined && optionsVis.campEtiqueta!=undefined){
					var style = "font-family:"+optionsVis.fontFamily+";font-size:"+optionsVis.fontSize+";color:"+optionsVis.fontColor;
					if (optionsVis.contorn!=undefined && optionsVis.contorn=="si") {
						style+=";text-shadow:1px 1px #ffffff";
					}
					else 	style+=";text-shadow:0px 0px #ffffff";
					if (optionsVis.fontStyle!=undefined){
						if (optionsVis.fontStyle=="normal" || optionsVis.fontStyle=="bold") style+= ";font-weight:"+optionsVis.fontStyle;
						else if (optionsVis.fontStyle=="italic") style+= ";font-style:"+optionsVis.fontStyle;
					}
					if (optionsVis.caixa!=undefined && optionsVis.caixa=="si"){
						style += ";background-color:"+optionsVis.caixaColor;
					}
					else style += ";background-color:transparent";
					style += ";border: 0px;box-shadow: none";
					InstamapsUtils.Dom.createClass('.etiqueta_style_'+layer.businessId,style);
				}
				var zoomInicialEtiqueta = "2";
				if (optionsVis!=undefined && optionsVis.zoomInicial!=undefined) zoomInicialEtiqueta=optionsVis.zoomInicial;
				var zoomFinalEtiqueta = "19";
				if (optionsVis!=undefined && optionsVis.zoomFinal!=undefined)  zoomFinalEtiqueta=optionsVis.zoomFinal;
				if (tipus=="Point") {
					if (optionsVis!=undefined && optionsVis.campEtiqueta!=undefined) {
						if (optionsVis!=undefined && optionsVis.opcionsVis!=undefined && 
								(optionsVis.opcionsVis=="nomesetiqueta" || optionsVis.opcionsVis=="etiquetageom")){
									var permanent = true;
								if (optionsVis.hoverEtiqueta!=undefined) permanent = (optionsVis.hoverEtiqueta!=="hover");	
								latlng.bindTooltip(pp[optionsVis.campEtiqueta],
								{opacity:1, permanent: permanent,interactive:true,  direction: 'center',className: "etiqueta_style_"+layer.businessId,offset: [0, 0]});						
						}
						if ((zoomInicialEtiqueta!=undefined && map.getZoom()<zoomInicialEtiqueta) ||
								(zoomFinalEtiqueta!=undefined && map.getZoom() > zoomFinalEtiqueta)) {//ocultem labels
								try{
									if (latlng.label!=undefined) latlng.label.setOpacity(0);
									else latlng.closeTooltip();
								}catch(err){
									
								}
						}
					}
				}
				else if (tipus=="LineString"){
					if (optionsVis!=undefined && optionsVis.campEtiqueta!=undefined) {
						if (optionsVis!=undefined && optionsVis.opcionsVis!=undefined) {
								if ((optionsVis.opcionsVis=="nomesetiqueta" || optionsVis.opcionsVis=="etiquetageom")  ){
									var permanent = true;
									if (optionsVis.hoverEtiqueta!=undefined) permanent = (optionsVis.hoverEtiqueta!=="hover");	
									latlng.bindTooltipEx(map,pp[optionsVis.campEtiqueta], 
											{ permanent: permanent, direction: 'center',className: "etiqueta_style_"+layer.businessId,interactive:true, offset: [0, 0]});
								}	
								if (optionsVis.opcionsVis=="geometries"){
									latlng.closeTooltip();
								}
								if ((zoomInicialEtiqueta!=undefined && map.getZoom()<zoomInicialEtiqueta) ||
										(zoomFinalEtiqueta!=undefined && map.getZoom() > zoomFinalEtiqueta)) {//ocultem labels
									latlng.closeTooltip();
								}
						}
					}
					//latlng.bindTooltipEx(map,"prova3", { permanent: true, direction: 'center',interactive:true, offset: [0, 0]});
				}
				else if (tipus=="Polygon"){
					if (optionsVis!=undefined && optionsVis.campEtiqueta!=undefined) {
						if (optionsVis!=undefined && optionsVis.opcionsVis!=undefined) {
								if ((optionsVis.opcionsVis=="nomesetiqueta" || optionsVis.opcionsVis=="etiquetageom")  ){
									var permanent = true;
									if (optionsVis.hoverEtiqueta!=undefined) permanent = (optionsVis.hoverEtiqueta!=="hover");	
									latlng.bindTooltipExPolygon(map,pp[optionsVis.campEtiqueta], 
										{ permanent: permanent, direction: 'center',className: "etiqueta_style_"+layer.businessId,interactive:true,offset: [0, 0] });
								}	
								if (optionsVis.opcionsVis=="geometries"){
									latlng.closeTooltip();
								}
								if ((zoomInicialEtiqueta!=undefined && map.getZoom()<zoomInicialEtiqueta) ||
										(zoomFinalEtiqueta!=undefined && map.getZoom() > zoomFinalEtiqueta)) {//ocultem labels
									latlng.closeTooltip();
								}
						}
					}
					//latlng.bindTooltipExPolygon(map,"prova4",	{ permanent: true, direction: 'center',interactive:true, offset: [0, 0] });
				}

				//latlng.feature.properties.capaNom = layer.serverName;
				//latlng.feature.properties.popupData=html;
				latlng.properties={
					capaNom: layer.serverName,
					popupData:html,
					feature: latlng.feature,
					data: latlng.feature.properties
				};
				if (tipus != 'Point'){
					latlng.on('click', function(e) {
						createPopupMapaUrlFile(latlng, e);
					});
				}
				
				//return PopupManager().createMergedDataPopup(feature, e, controlCapes);;
			}
		});	
	}	
	/**
	 * TEMATIC CLASIC O MIDES
	 */	
	else if(tipusTem == tem_clasic || tipusTem == tem_size){
		var tipusAcc = options.tipusAcc;
		if (tipusAcc === undefined && optionsMare!==undefined) tipusAcc = optionsMare.tipusAcc;
		var tipusCodi = options.tipusCodi;
		if (tipusCodi === undefined && optionsMare!==undefined) tipusCodi = optionsMare.tipusCodi;
		var tipusFont = options.tipusFont;
		if (tipusFont === undefined && optionsMare!==undefined) tipusFont = optionsMare.tipusFont;
		var nomCampCodi = options.nomCampCodi;
		if (nomCampCodi === undefined && optionsMare!==undefined) nomCampCodi = optionsMare.nomCampCodi;
		var separador = options.separador;
		if (separador === undefined && optionsMare!==undefined) separador = optionsMare.separador;

		if(tipusTem == tem_size && tipusAcc == undefined){
			defer.reject({msg:'server_bad_options'});
			return defer.promise();
		}else{
		
		options.nom = layer.serverName;
		options.businessId = layer.businessId;

		param_url += "&tipusAcc="+tipusAcc+
			"&tipusCodi="+tipusCodi+
			"&tipusFont="+tipusFont+
			"&nomCampCodi="+nomCampCodi+
			"&separador="+separador;
		
		//SOCRATA		
		if ((urlFile.indexOf("socrata")>-1 || urlFile.indexOf("https")>-1) && (urlFile.indexOf("drive")==-1)  && (urlFile.indexOf("spreadsheet")==-1)
				&& (urlFile.indexOf("dropbox")==-1) && (urlFile.indexOf("csv")==-1) && (urlFile.indexOf("sharepoint")==-1)) 	{
			param_url = urlFile;
		}
		if (urlFile.indexOf("jsonfiles")>-1) {
			param_url = urlFile;
			if (param_url.indexOf("https")==-1  && urlApp.indexOf("geocat1")==-1   && urlApp.indexOf("localhost")==-1 && urlFile.indexOf("dropbox")==-1 &&  urlFile.indexOf("sharepoint")==-1 && urlFile.indexOf("analisi.transparenciacatalunya.cat/")==-1) param_url = param_url.replace("http","https");//modifiquem https
		}
		//if (urlFile.indexOf("socrata")>-1)	param_url = urlFile;
		var geomsNoTrobades=false;
		capaURLfileLoad = new L.GeoJSON.AJAX(param_url, {
			nom : layer.serverName,
			tipus : layer.serverType, 
			geometryType: geometryType,
			businessId : layer.businessId,
			pointToLayer : function(feature, latlng) {
				var estilGeom=estil_do;  //ficat default point style????
				var geom = null;	 
				var pp = feature.properties;
				var dataFieldValue = "";
				var html ='<div class="div_popup_visor"><div class="popup_pres">';
				$.each( pp, function( key, value ) {
					try{
						if(InstamapsUtils.Validator.isValidValueNotWKT(value)){
							if ( key != 'businessId' && key != 'slotd50'  && key.toLowerCase()!="nomcapa" && key.toLowerCase()!="popupdata" &&
									key.toLowerCase()!="capanom" && key.toLowerCase()!="propname"){
										html += InstamapsUtils.Dom.getHtmlFromTxt(value,key);			
							}
						}

						if(key.toLowerCase()==estil_do.dataField || key==estil_do.dataField) dataFieldValue = value;
					}catch(e){
						console.debug(e);
					}
				});	
				html+='</div></div>';    	
				var codiEstil = '';
				try{
					var geomTrobat=false;
					
					$.each( estil_do.estils, function( index, estil ) {
						if((estil.valueMax == estil.valueMin && dataFieldValue == estil.valueMax) || //rang unic
								(parseFloat(dataFieldValue)>=parseFloat(estil.valueMin) && parseFloat(dataFieldValue)<=parseFloat(estil.valueMax))){//per valors	
							geom = L.circleMarker(latlng, { radius : estil.estil.simbolSize, fillColor : estil.estil.color, color : "#ffffff", weight : 2, opacity : 1, fillOpacity : 0.9, isCanvas: true });
							if (estil.codiUnic!==undefined) codiEstil = estil.codiUnic;
							geomTrobat=true;
							return;
						}
					});
					if (!geomTrobat) {
						geomsNoTrobades=true;
						geom = L.circleMarker(latlng, { radius : 6, fillColor : "#444", color : "#ffffff", weight : 2, opacity : 1, fillOpacity : 0.9, isCanvas: true });						
					}
				}catch(e){
					console.debug(e);
				}
				   	
				feature.properties.capaNom=layer.serverName;
				feature.properties.popupData=html;
				feature.properties.codiEstil = codiEstil;
				geom.on('click', function(e) {
					createPopupMapaUrlFile(feature, e);
				});
				
				return geom;
			},
			onEachFeature : function(feature, latlng) {
				var pp = feature.properties;
				var dataFieldValue = "";
				var html ='<div class="div_popup_visor"><div class="popup_pres">';
				$.each( pp, function( key, value ) {
					try{
						if(InstamapsUtils.Validator.isValidValueNotWKT(value)){
							if ( key != 'businessId' && key != 'slotd50'  && key.toLowerCase()!="nomcapa" && key.toLowerCase()!="popupdata" &&
									key.toLowerCase()!="capanom" && key.toLowerCase()!="propname"){
										html += InstamapsUtils.Dom.getHtmlFromTxt(value,key);			
							}
						}
						if(key.toLowerCase()==estil_do.dataField || key==estil_do.dataField) dataFieldValue = value;
					}catch(e){
						console.debug(e);
					}
				});	
				html+='</div></div>'; 
				var codiEstil = '';
				try{
				var geomTrobat=false;
				
				$.each( estil_do.estils, function( index, estil ) {
					if((estil.valueMax == estil.valueMin && dataFieldValue == estil.valueMax) || //rang unic
							(parseFloat(dataFieldValue)>=parseFloat(estil.valueMin) && parseFloat(dataFieldValue)<=parseFloat(estil.valueMax))){//per valors	
						if (estil.codiUnic!==undefined) codiEstil = estil.codiUnic;
						if (latlng.feature.geometry.type.toLowerCase() == t_marker || latlng.feature.geometry.type.toLowerCase() == "point"){
							latlng.setStyle(
								{ radius : estil.estil.simbolSize, 
								  fillColor : estil.estil.color, 
								  color : "#ffffff", 
								  weight : 2, 
								  opacity : 1, 
								  fillOpacity : 0.9, 
								  isCanvas: true 
							});
						}
						else if(latlng.feature.geometry.type.toLowerCase() == t_polygon ){		
							latlng.setStyle({
								weight: 2,
								fillColor: estil.estil.color,
								color: estil.estil.borderColor,
								fillOpacity: 0.5,
								opacity: 1
							});
						}else if(latlng.feature.geometry.type.toLowerCase().indexOf(t_polyline)!=-1 
								|| latlng.feature.geometry.type.toLowerCase().indexOf(t_linestring)!=-1){
							latlng.setStyle({
								weight: 2,
								color: estil.estil.color,
								fillOpacity: 1,
								opacity: 1
							});
						}else if(latlng.feature.geometry.type.toLowerCase() == t_multipolygon ){
							latlng.setStyle({
								weight: 2,
								fillColor: estil.estil.color,
								color: estil.estil.borderColor,
								fillOpacity: 0.5,
								opacity: 1
							});
						}
						geomTrobat=true;
						return false;	
					}					
				});	
				if (!geomTrobat) {
					geomsNoTrobades=true;
					if (latlng.feature.geometry.type.toLowerCase() == t_marker || latlng.feature.geometry.type.toLowerCase() == "point"){
						latlng.setStyle(
							{ radius : 6, 
							  fillColor : "#444", 
							  color : "#ffffff", 
							  weight : 2, 
							  opacity : 1, 
							  fillOpacity : 0.9, 
							  isCanvas: true 
						});
					}
					else if(latlng.feature.geometry.type.toLowerCase() == t_polygon ){		
						latlng.setStyle({
							weight: 2,
							fillColor: "#444", 
							color: "#444", 
							fillOpacity: 0.5,
							opacity: 1
						});
					}else if(latlng.feature.geometry.type.toLowerCase().indexOf(t_polyline)!=-1 
							|| latlng.feature.geometry.type.toLowerCase().indexOf(t_linestring)!=-1){
						latlng.setStyle({
							weight: 2,
							color: "#444", 
							fillOpacity: 1,
							opacity: 1
						});
					}else if(latlng.feature.geometry.type.toLowerCase() == t_multipolygon ){
						latlng.setStyle({
							weight: 2,
							fillColor: "#444", 
							color:"#444", 
							fillOpacity: 0.5,
							opacity: 1
						}); 
					}
					return false;
				}
				}catch(e){
					console.debug(e);
				}

				latlng.feature.properties.capaNom = layer.serverName;
				latlng.feature.properties.popupData=html;
				latlng.feature.properties.codiEstil = codiEstil;
				latlng.properties={
					capaNom: layer.serverName,
					popupData:html,
					feature: latlng.feature,
					data: latlng.feature.properties,
					codiEstil : codiEstil
				};
				var tipus = feature.geometry.type;
				if (tipus != 'Point'){
					latlng.on('click', function(e) {
						createPopupMapaUrlFile(latlng, e);
					});
				}

				return latlng;
			}
		});

		capaURLfileLoad.on('data:loaded', function(e){
			if ($(location).attr('href').indexOf('/visor.html') === -1 && $(location).attr('href').indexOf('instavisor') === -1) { 
				if (geomsNoTrobades){ //si no troba les categories perquè els valors es modifiquen que aparegui un alert avisant
					var warningMSG="Hem detectat a la visualització "+layer.serverName+" elements que no queden recollits a l’estil definit i que s’han representat en gris fosc. Cal fer una nova estilització que reculli el conjunt dels elements i tornar a publicar el mapa.";
					alert(warningMSG);
				}
			}			
		});

		}
		
	}	
	/**
	 * TEMATIC CLUSTER
	 */	
	else if(tipusTem == tem_cluster){
		var tipusAcc = options.tipusAcc;
		if (tipusAcc === undefined && optionsMare!==undefined) tipusAcc = optionsMare.tipusAcc;
		var tipusCodi = options.tipusCodi;
		if (tipusCodi === undefined && optionsMare!==undefined) tipusCodi = optionsMare.tipusCodi;
		var tipusFont = options.tipusFont;
		if (tipusFont === undefined && optionsMare!==undefined) tipusFont = optionsMare.tipusFont;
		var nomCampCodi = options.nomCampCodi;
		if (nomCampCodi === undefined && optionsMare!==undefined) nomCampCodi = optionsMare.nomCampCodi;
		var separador = options.separador;
		if (separador === undefined && optionsMare!==undefined) separador = optionsMare.separador;

		param_url += "&tipusAcc="+tipusAcc+
			"&tipusCodi="+tipusCodi+
			"&tipusFont="+tipusFont+
			"&nomCampCodi="+nomCampCodi+
			"&separador="+separador;
		param_url += "&tem="+tem_cluster;	
		//SOCRATA		
		if ((urlFile.indexOf("socrata")>-1 || urlFile.indexOf("https")>-1) && (urlFile.indexOf("drive")==-1)  && (urlFile.indexOf("spreadsheet")==-1)
				&& (urlFile.indexOf("dropbox")==-1) && (urlFile.indexOf("csv")==-1) && (urlFile.indexOf("sharepoint")==-1)) 	{
			param_url = urlFile;
		}
		if (urlFile.indexOf("jsonfiles")>-1) {
			param_url = urlFile;
			if (param_url.indexOf("https")==-1  && urlApp.indexOf("geocat1")==-1 && urlFile.indexOf("dropbox")==-1 && urlFile.indexOf("sharepoint")==-1 && urlFile.indexOf("analisi.transparenciacatalunya.cat/")==-1) param_url = param_url.replace("http","https");//modifiquem https
		}
		capaURLfileLoad = new L.GeoJSON.AJAX(param_url, {
			nom : layer.serverName,
			tipus : layer.serverType,
			geometryType: geometryType,
			estil_do: estil_do,
			businessId : layer.businessId,
			pointToLayer : function(feature, latlng) {
				var geom = L.circleMarker(latlng, estil_do);
				var pp = feature.properties;
				var html ='<div class="div_popup_visor"><div class="popup_pres">';
				$.each( pp, function( key, value ) {
					if(InstamapsUtils.Validator.isValidValueNotWKT(value)){
						if ( key != 'businessId' && key != 'slotd50'  && key.toLowerCase()!="nomcapa" && key.toLowerCase()!="popupdata" &&
								key.toLowerCase()!="capanom" && key.toLowerCase()!="propname"){
									html += InstamapsUtils.Dom.getHtmlFromTxt(value,key);			
						}
					}
				});		
				html+='</div></div>'; 
				feature.properties.capaNom=layer.serverName;
				feature.properties.popupData=html;
			
				geom.on('click', function(e) {
					createPopupMapaUrlFile(feature, e);
				});
				return geom;				
			}
		});
	}
	/**
	 * TEMATIC HEATMAP
	 */
	else if(tipusTem == tem_heatmap){
		var tipusAcc = options.tipusAcc;
		if (tipusAcc === undefined && optionsMare!==undefined) tipusAcc = optionsMare.tipusAcc;
		var tipusCodi = options.tipusCodi;
		if (tipusCodi === undefined && optionsMare!==undefined) tipusCodi = optionsMare.tipusCodi;
		var tipusFont = options.tipusFont;
		if (tipusFont === undefined && optionsMare!==undefined) tipusFont = optionsMare.tipusFont;
		var nomCampCodi = options.nomCampCodi;
		if (nomCampCodi === undefined && optionsMare!==undefined) nomCampCodi = optionsMare.nomCampCodi;
		var separador = options.separador;
		if (separador === undefined && optionsMare!==undefined) separador = optionsMare.separador;

		param_url += "&tipusAcc="+tipusAcc+
			"&tipusCodi="+tipusCodi+
			"&tipusFont="+tipusFont+
			"&nomCampCodi="+nomCampCodi+
			"&separador="+separador;		
		param_url += "&tem="+tem_heatmap;	
		//SOCRATA		
		if ((urlFile.indexOf("socrata")>-1 || urlFile.indexOf("https")>-1) && (urlFile.indexOf("drive")==-1)  && (urlFile.indexOf("spreadsheet")==-1)
				&& (urlFile.indexOf("dropbox")==-1) && (urlFile.indexOf("csv")==-1) && (urlFile.indexOf("sharepoint")==-1)) 	{
			param_url = urlFile;
		}
		if (urlFile.indexOf("jsonfiles")>-1) {
			param_url = urlFile;
			if (param_url.indexOf("https")==-1  && urlApp.indexOf("geocat1")==-1 && urlFile.indexOf("dropbox")==-1 && urlFile.indexOf("sharepoint")==-1 && urlFile.indexOf("analisi.transparenciacatalunya.cat/")==-1) param_url = param_url.replace("http","https");//modifiquem https
		}
		capaURLfileLoad = new L.GeoJSON.AJAX(param_url, {
			nom : layer.serverName,
			tipus : layer.serverType,
			geometryType: geometryType,
			estil_do: estil_do,
			businessId : layer.businessId,
			pointToLayer : function(feature, latlng) {
				var geom = L.circleMarker(latlng, estil_do);
				feature.properties.capaNom=layer.serverName;
				feature.properties.popupData=html;
				geom.on('click', function(e) {
					createPopupMapaUrlFile(feature, e);
				});
				
				/*var popup = L.popup().setContent("");
				return geom.bindPopup(popup);*/
				return geom;
			}
		});
	}
	
	capaURLfileLoad.on('data:loaded', function(e){
		var self = this;
		var layerTmp;
		var objLayer = {activa: false, layer: null};
		if (true === layer.capesActiva || 'true' === layer.capesActiva){
			objLayer.activa = true;
		}
		if(tipusTem == null || tipusTem == tem_simple){
			self.options = options;
			layerTmp =addLayerUrlToMap(capaURLfileLoad, layer, controlCapes, origen, map);
		}else if(tipusTem == tem_clasic || tipusTem == tem_size){
			self.options = options;
			layerTmp =addLayerUrlToMap(capaURLfileLoad, layer, controlCapes, origen, map);
			if ($(location).attr('href').indexOf('/mapa.html')!=-1){
				//loadMapLegendEdicioDinamics(self);
			}
		}else if(tipusTem == tem_cluster){
			var clusterLayer = L.markerClusterGroup({
				singleMarkerMode : true
			});
			capaURLfileLoad.eachLayer(function(layer) {
				var marker = L.marker(new L.LatLng(layer.getLatLng().lat, layer.getLatLng().lng), {
					title : layer._leaflet_id
				});				
				var feature = layer.feature;
				feature.properties.capaNom=layer.nom;
				feature.htmlContent = layer.feature.properties.popupData;					
				var dataF = {};
				dataF.features = [];
				dataF.features[0] = feature;
				marker.on('click', function(e) {					
					$.publish('showPinPopup', dataF);
				});
				
				clusterLayer.addLayer(marker);
			});
			
			clusterLayer.options.businessId = layer.businessId;
			clusterLayer.options.nom = layer.serverName;
			clusterLayer.options.zIndex = parseInt(layer.capesOrdre);
			clusterLayer.options.tipus = layer.serverType;
			clusterLayer.options.dataset = options.dataset;
			clusterLayer.options.tipusRang = tem_cluster;
			if(self.error){
				clusterLayer.error = true;
			}
			
			layerTmp =addLayerUrlToMap(clusterLayer, layer, controlCapes, origen, map);
			
		}else if(tipusTem == tem_heatmap){
			var arrP=[];
			self.options = options;
			capaURLfileLoad.eachLayer(function(layer){
				var d = [layer.getLatLng().lat,layer.getLatLng().lng,1];	
				arrP.push(d);	
			});

			var heatLayerActiu = L.heatLayer(arrP,{
				radius:20,
				blur:15,
				max:1,
				gradient: {			
					0.35: "#070751",
					0.40: "#0095DE",
					0.45: "#02D5FF",
					0.50: "#02E0B9",
					0.55: "#00B43F",
					0.60: "#97ED0E",
					0.61: "#FFF800",
					0.65: "#FF9700",
					0.70: "#FF0101",
					1: "#720404"
				}	
			});

			heatLayerActiu.options.businessId = layer.businessId;
			heatLayerActiu.options.nom = layer.serverName;
			heatLayerActiu.options.zIndex = parseInt(layer.capesOrdre);
			heatLayerActiu.options.tipus = layer.serverType;
			heatLayerActiu.options.tipusRang = tem_heatmap;
			if(self.error){
				heatLayerActiu.error = true;
			}
			layerTmp =addLayerUrlToMap(heatLayerActiu, layer, controlCapes, origen, map);	
		}
		objLayer.layer = layerTmp;
		defer.resolve(objLayer);
		
	});
		
	capaURLfileLoad.on('data:progress', function (e) {
		if (e.error) {
			// handle error
			var self = this;
			self.error = true;
			defer.reject(e.error);
		}
	});
	
	return defer.promise();
	
}

function addLayerUrlToMap(capaURLfileLoad, layer, controlCapes, origen, map){	

	if (!layer.capesOrdre || layer.capesOrdre == null || layer.capesOrdre == 'null'){
		capaURLfileLoad.options.zIndex = controlCapes._lastZIndex + 1;
	}else if(layer.capesOrdre != capesOrdre_sublayer){
		capaURLfileLoad.options.zIndex = parseInt(layer.capesOrdre);
	}		

	if(!origen){
		capaURLfileLoad.options.businessId = layer.businessId;
		if(controlCapes){
			controlCapes.addOverlay(capaURLfileLoad, layer.serverName, true);
			controlCapes._lastZIndex++;	
		}
	}else{//Si te origen es una sublayer
		var origenL = InstamapsUtils.Mapa.getLeafletIdFromBusinessId(origen, controlCapes);
		capaURLfileLoad.options.zIndex = capesOrdre_sublayer;
		if(controlCapes){
			controlCapes.addOverlay(capaURLfileLoad, layer.serverName, true, origenL);
			$( "#input-"+layer.businessId).click();
		}
		
	}
	
	if (layer.capesActiva== null || layer.capesActiva == 'null' || layer.capesActiva == true || layer.capesActiva == "true"){
		capaURLfileLoad.addTo(map);
	}
	return capaURLfileLoad;	
	
}

function constructLayer(layer, estil_do){
	layer.eachLayer(function(marker) {
		var geometryType = InstamapsUtils.Geo.transformTipusGeometry(marker.feature.geometry.type, InstamapsConstants);
		if(geometryType == t_marker){
			var geom = L.circleMarker(marker._latlng, estil_do);
		}else if(geometryType == t_polyline){
			var geom = L.polyline(marker._latlngs, {color: estil_do.fillColor, weight: "3", opacity: "1"});
		}else if(geometryType == t_polygon){
			var geom = L.polygon(marker._latlngs, {color: estil_do.color, fillColor: estil_do.fillColor, fillOpacity: estil_do.fillOpacity, weight: estil_do.weight});
		}
		var pp = marker.toGeoJSON().properties;
		var html ='<div class="div_popup_visor"><div class="popup_pres">';
		$.each( pp, function( key, value ) {
			if(InstamapsUtils.Validator.isValidValueNotWKT(value)){
				if ( key != 'businessId' && key != 'slotd50'  && key.toLowerCase()!="nomcapa" && key.toLowerCase()!="popupdata" &&
						key.toLowerCase()!="capanom" && key.toLowerCase()!="propname"){
							html += InstamapsUtils.Dom.getHtmlFromTxt(value,key);			
				}
			}
		});		
		html+='</div></div>';    	

		geom.properties = { capaNom: layer.serverName };
		geom.popupData = html;

		geom.on('click', function(e) {
			createPopupMapaUrlFile(geom, e);
		});
		
		layer.removeLayer(marker);
		layer.addLayer(geom);
	});
}
function createPopupMapaUrlFile(geom, event){
	$.publish('createPopupOnclick', {event: event, element: geom});
}

function defineGeometryType(data){
	if(data.indexOf("Point")!=-1){
		return t_point;
	}else if(data.indexOf("Line")!=-1){
		return t_linestring;
	}else if(data.indexOf("Polygon")!=-1){
		return t_polygon;
	}
}

function parseGeojsonStyle(data){
	var dataParse  = JSON.parse(data);
	console.debug(dataParse);			
}

function loadUrlFileHeatmapLayer(layer){
	PopupManager();
	var options = jQuery.parseJSON( layer.options );
	var style = options.style;
	var tipusFile = options.tipusFile;
	var geometryType = options.geometryType;
	var epsgIN = options.epsgIN;
	var colX = options.colX;
	var colY = options.colY;
	var colWKT = options.colWKT;
	var urlFile = layer.url;
	var dinamic = options.dinamic;
	var campUnic = options.campUnic; 
	var camps = options.camps;
	var separador = options.separador;
	var param_url = paramUrl.urlFileDin + 
	"tipusFile=" + tipusFile+
	"&colX="+colX+
	"&colY="+colY+
	"&colWKT="+colWKT+
	"&epsgIN="+epsgIN+
	"&dinamic="+dinamic+
	"&campUnic="+campUnic+
	"&camps="+camps+
	"&separador="+separador+
	"&urlFile="+encodeURIComponent(urlFile);	

	var capaURLfileLoad = new L.GeoJSON.AJAX(param_url, {
		nom : layer.serverName,
		tipus : layer.serverType,
		geometryType: geometryType,
		estil_do: estil_do,
		style: style,
		businessId : layer.businessId,
		pointToLayer : function(feature, latlng) {
			var geom = L.circleMarker(latlng, estil_do);
			feature.properties.capaNom=layer.serverName;
			feature.properties.popupData=html;
			geom.on('click', function(e) {
				createPopupMapaUrlFile(feature, e);
			});
			
		}
	});		

	capaURLfileLoad.on('data:loaded', function(e){

		var arrP=[];
		capaURLfileLoad.eachLayer(function(layer){
			var d =[layer.getLatLng().lat,layer.getLatLng().lng,1];	
			arrP.push(d);			
		});

		var heatLayerActiu = L.heatLayer(arrP,{radius:20,blur:15,max:1,
			gradient: {			
				0.35: "#070751",
				0.40: "#0095DE",
				0.45: "#02D5FF",
				0.50: "#02E0B9",
				0.55: "#00B43F",
				0.60: "#97ED0E",
				0.61: "#FFF800",
				0.65: "#FF9700",
				0.70: "#FF0101",
				1: "#720404"
			}	
		});

		heatLayerActiu.options.businessId = layer.businessId;
		heatLayerActiu.options.nom = layer.serverName;
		heatLayerActiu.options.zIndex = parseInt(layer.capesOrdre);
		heatLayerActiu.options.tipus = layer.serverType;
		heatLayerActiu.options.tipusRang = tem_heatmap;

		if (layer.capesActiva == true || layer.capesActiva == "true"){
			map.addLayer(heatLayerActiu);
		}

		var origen = InstamapsUtils.Mapa.getLeafletIdFromBusinessId(options.origen, controlCapes);
		if(controlCapes){
			controlCapes.addOverlay(heatLayerActiu,	heatLayerActiu.options.nom, true, origen);
		}
		InstamapsUtils.Mapa.activaPanelCapes(true, jQuery);
		if(InstamapsUtils.Validator.isModeMapa($(location).attr('href'))){
			updateSortablesElements();
		}		
	});

}


